gsap.registerPlugin(ScrollTrigger, SplitText);
// Su mobile `resize` scatta anche solo per la comparsa/scomparsa della barra
// degli indirizzi, cioè durante lo scroll: senza questo flag ScrollTrigger
// ricalcolerebbe start/end a metà animazione.
ScrollTrigger.config({ ignoreMobileResize: true });
console.log('main.js loaded - 21/07/2026');
// Abilita di default la navigazione da tastiera (frecce) su OGNI istanza Swiper
// del sito, senza dover intervenire su ognuna delle decine di `new Swiper(...)`
// sparse nel file. Rispetta un `keyboard` esplicito già passato nelle options.
(function enableSwiperKeyboardByDefault() {
  const OriginalSwiper = window.Swiper;
  if (!OriginalSwiper) return;
  window.Swiper = function (el, options) {
    options = options || {};
    if (!options.keyboard) {
      options.keyboard = { enabled: true, onlyInViewport: true };
    }
    return new OriginalSwiper(el, options);
  };
  window.Swiper.prototype = OriginalSwiper.prototype;
}());

// ============================================================
// shared helpers (usati da più moduli sotto)
// ============================================================

// Rimuove dal tab order (e dall'accessibility tree, dove aggiunto da Swiper) qualunque
// elemento focusabile dentro un sottoalbero aria-hidden="true".
// Regola W3C: un sottoalbero aria-hidden non deve contenere elementi nella navigazione sequenziale.
const ARIA_HIDDEN_FOCUSABLES = [
  '[aria-hidden="true"] a[href]',
  '[aria-hidden="true"] button',
  '[aria-hidden="true"] input',
  '[aria-hidden="true"] select',
  '[aria-hidden="true"] textarea',
  '[aria-hidden="true"] [tabindex]:not([tabindex="-1"])',
  '[aria-hidden="true"] [role="button"]',
].join(', ');

const ARIA_HIDDEN_NATIVE_INTERACTIVE = /^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/;

function sanitizeAriaHiddenControls(root) {
  if (!root) return;
  root.querySelectorAll(ARIA_HIDDEN_FOCUSABLES).forEach(function (el) {
    if (!el.hasAttribute('data-a11y-prev-tabindex')) {
      el.setAttribute('data-a11y-prev-tabindex', el.getAttribute('tabindex') || '');
    }
    el.setAttribute('tabindex', '-1');
    // role/aria-label vanno rimossi solo dove li ha aggiunti Swiper (div/span decorati),
    // non da un elemento nativamente interattivo.
    if (!ARIA_HIDDEN_NATIVE_INTERACTIVE.test(el.tagName)) {
      el.removeAttribute('role');
      el.removeAttribute('aria-label');
    }
  });
}

// ============================================================
// createFocusLoopGuard — congela/rimonta il loop infinito di uno Swiper quando il
// focus (da tastiera o da screen reader assistivo) entra nel carosello, per evitare
// il focus trap: Swiper 12 in loop non clona le slide, sposta fisicamente i nodi DOM.
// ============================================================

// Singleton a livello di modulo: traccia solo la direzione di un Tab appena premuto,
// effimera (vale solo per il focus che segue immediatamente il keydown). Non traccia
// lo stato del puntatore — quello è per istanza dentro il factory, perché deve sapere
// se il tocco è atterrato dentro UNA specifica swiperEl e leggere il suo swiper.allowClick.
const tabDirectionSignal = (function () {
  let direction = null;
  let armed = false;
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      direction = e.shiftKey ? 'backward' : 'forward';
    } else if (e.key.indexOf('Arrow') === 0) {
      direction = null;
    } else {
      return;
    }
    armed = true;
    // Direzione effimera: scade al frame successivo, così un Tab atterrato fuori dal
    // carosello non può dirottare un ingresso successivo via screen reader.
    requestAnimationFrame(function () { armed = false; direction = null; });
  }, true);
  return {
    getDirection: function () { return armed ? direction : null; },
  };
}());

// Il loop infinito dei caroselli è una richiesta esplicita del cliente (2026-09-18), che
// ha fatto annullare il passaggio a rewind del 2026-09-07. Questo guard rimette in ordine
// il DOM mentre si naviga da tastiera. Non copre VoiceOver sulle card composte: lì il
// focus DOM non si muove, quindi il lettore percorre le slide nell'ordine riordinato da
// Swiper e parte dall'ultima.
function createFocusLoopGuard(swiper, swiperEl, options) {
  options = options || {};
  if (!swiper.params.loop) return null;

  let frozen = false;
  let mutating = false;
  // Attivazione pendente su QUESTA istanza: true dal pointerdown fino alla risoluzione causale (click,
  // pointercancel, o allowClick che diventa false su un drag riconosciuto).
  let pendingActivation = false;
  let pendingClick = null;
  let pendingPointerEnd = null;

  function withPreservedFocus(fn) {
    mutating = true;
    // Il modulo a11y di Swiper ascolta 'focus' in capture su swiperEl e, se
    // params.a11y.scrollOnFocus è attivo, schedula una slideTo verso la slide del
    // nodo che ha ricevuto il focus. Durante la nostra mutazione gli unici spostamenti
    // di focus sono i nostri (il ripristino dopo il riordino dei nodi): se li lasciassimo
    // passare, Swiper scorrerebbe verso la slide "vecchia" un frame dopo, sovrascrivendo
    // alignEntry e lasciando focus e slide mostrata disallineati. Il flag viene letto in
    // modo sincrono all'evento, quindi azzerarlo qui basta a far uscire subito il suo
    // handler, senza che arrivi a schedulare nulla.
    const a11y = swiper.params.a11y;
    const prevScrollOnFocus = a11y ? a11y.scrollOnFocus : undefined;
    if (a11y) a11y.scrollOnFocus = false;

    const active = document.activeElement;
    const restore = active && swiperEl.contains(active) ? active : null;
    fn();
    if (restore && document.activeElement !== restore) restore.focus({ preventScroll: true });
    requestAnimationFrame(function () {
      mutating = false;
      if (a11y) a11y.scrollOnFocus = prevScrollOnFocus;
    });
  }

  function freeze() {
    if (frozen || mutating || !swiper.params.loop) return;
    frozen = true;
    withPreservedFocus(function () {
      swiper.loopDestroy();
      swiper.params.loop = false;
      swiper.update();
    });
    if (options.onFreeze) options.onFreeze();
  }

  function unfreeze() {
    if (!frozen || mutating) return;
    // non riordinare mai durante una transizione
    if (swiper.animating) {
      swiper.once('transitionEnd', function () { requestAnimationFrame(unfreeze); });
      return;
    }
    frozen = false;
    const realIndex = swiper.realIndex;
    withPreservedFocus(function () {
      swiper.params.loop = true;
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
      swiper.update();
      swiper.slideToLoop(realIndex, 0, false);
    });
    if (options.onUnfreeze) options.onUnfreeze();
  }

  // La barriera rAF lascia che Swiper elabori il pointerup PRIMA di guardare
  // swiper.animating: il listener in capture gira prima di Swiper.
  function deferUnfreeze() {
    requestAnimationFrame(function () {
      if (swiper.animating) {
        swiper.once('transitionEnd', function () { requestAnimationFrame(unfreeze); });
        return;
      }
      unfreeze();
    });
  }

  // click è il segnale che chiude un'attivazione: se arriva, l'unfreeze è sicuro
  // perché la mutazione avviene DOPO che il tap ha già navigato. Il ramo drag si
  // riconosce da swiper.allowClick (true in touchStart, false in touchMove appena il
  // drag inizia davvero — verificato sul bundle Swiper 12.0.3 vendorizzato), letto al
  // pointerup: il valore è già deciso dalla fase di movimento, quindi è causale e non
  // racy. Nessun timeout: un tap candidate senza click lascia il loop congelato, che è
  // lo stato sicuro (un carosello senza loop, non un trap), non uno stato rotto.
  function attachPointerEnd() {
    detachPointerEnd();

    // Scoped al carosello: un click estraneo prodotto altrove nel documento durante
    // la finestra pendente non deve far scattare l'unfreeze qui.
    pendingClick = function (e) {
      if (!swiperEl.contains(e.target)) return;
      detachPointerEnd();
      deferUnfreeze();
    };

    pendingPointerEnd = function (e) {
      if (e.type === 'pointercancel') {
        detachPointerEnd();
        deferUnfreeze();
        return;
      }
      if (swiper.allowClick === false) {
        detachPointerEnd();
        deferUnfreeze();
        return;
      }
      // Tap candidate: resta in attesa del click, nessuna mutazione.
    };

    document.addEventListener('click', pendingClick, true);
    document.addEventListener('pointerup', pendingPointerEnd, true);
    document.addEventListener('pointercancel', pendingPointerEnd, true);
  }

  function detachPointerEnd() {
    if (pendingClick) {
      document.removeEventListener('click', pendingClick, true);
      pendingClick = null;
    }
    if (pendingPointerEnd) {
      document.removeEventListener('pointerup', pendingPointerEnd, true);
      document.removeEventListener('pointercancel', pendingPointerEnd, true);
      pendingPointerEnd = null;
    }
  }

  function onPointerDown(e) {
    if (!frozen) return;
    if (swiperEl.contains(e.target)) {
      // non riordinare tra pointerdown e l'attivazione, altrimenti il click si perde
      attachPointerEnd();
    } else {
      deferUnfreeze();
    }
  }

  // uscita del focus → scongela (activeElement è più affidabile di relatedTarget)
  function onFocusOut() {
    if (mutating || swiper.destroyed) return;
    requestAnimationFrame(function () {
      if (mutating || swiper.destroyed) return;
      if (!swiperEl.contains(document.activeElement)) unfreeze();
    });
  }

  // Ascolto permanente (non solo mentre frozen): deve classificare correttamente
  // anche il primissimo focusin, prima che il carosello sia mai stato congelato.
  function onActivationPointerDown(e) {
    pendingActivation = swiperEl.contains(e.target);
  }
  function onActivationPointerUp() {
    if (pendingActivation && swiper.allowClick === false) pendingActivation = false;
  }
  function onActivationPointerCancel() {
    pendingActivation = false;
  }
  function onActivationClick(e) {
    if (swiperEl.contains(e.target)) pendingActivation = false;
  }

  // Riallinea solo quando la direzione è nota (Tab/Shift+Tab appena premuto)
  function alignEntry(direction) {
    const targetIndex = direction === 'forward' ? 0 : swiper.slides.length - 1;
    const targetSlide = swiper.slides[targetIndex];
    if (!targetSlide) return;
    const targetLink = targetSlide.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (targetLink && targetLink !== document.activeElement) {
      swiper.slideTo(targetIndex, 0);
      targetLink.focus({ preventScroll: true });
      // Il modulo a11y di Swiper ascolta 'focus' in CAPTURE su swiper.el, quindi gira
      // prima del nostro handler: sull'evento che ci ha portati qui ha già catturato la
      // slide su cui il browser aveva posato il focus e ha schedulato una slideTo
      // differita di un frame. Quella callback calcola l'indice sul DOM che nel frattempo
      // abbiamo riordinato col freeze, quindi punterebbe alla slide sbagliata lasciando
      // focus e slide mostrata disallineati. Le callback di requestAnimationFrame vengono
      // eseguite nell'ordine di registrazione: registrando la nostra dopo, l'ultima parola
      // resta la nostra. Nessun timeout, solo l'ordine garantito delle callback.
      requestAnimationFrame(function () {
        if (!swiper.destroyed && swiper.activeIndex !== targetIndex) {
          swiper.slideTo(targetIndex, 0);
        }
      });
    }
  }

  function onFocusIn(e) {
    if (mutating || swiper.destroyed) return;

    // Un Tab appena premuto ha la precedenza su qualunque stato pointer residuo:
    // senza questa riga un tap patologico bloccherebbe per sempre il freeze da
    // tastiera.
    const direction = tabDirectionSignal.getDirection();
    if (pendingActivation && !direction) return;
    if (direction) pendingActivation = false;

    const fromOutside = !swiperEl.contains(e.relatedTarget);
    freeze();
    if (fromOutside && direction && options.entryAlign !== false) alignEntry(direction);
  }

  document.addEventListener('pointerdown', onActivationPointerDown, true);
  document.addEventListener('pointerup', onActivationPointerUp, true);
  document.addEventListener('pointercancel', onActivationPointerCancel, true);
  document.addEventListener('click', onActivationClick, true);

  swiperEl.addEventListener('focusin', onFocusIn);
  swiperEl.addEventListener('focusout', onFocusOut);
  document.addEventListener('pointerdown', onPointerDown, true);

  return {
    freeze: freeze,
    unfreeze: unfreeze,
    isFrozen: function () { return frozen; },
    destroy: function () {
      document.removeEventListener('pointerdown', onActivationPointerDown, true);
      document.removeEventListener('pointerup', onActivationPointerUp, true);
      document.removeEventListener('pointercancel', onActivationPointerCancel, true);
      document.removeEventListener('click', onActivationClick, true);
      swiperEl.removeEventListener('focusin', onFocusIn);
      swiperEl.removeEventListener('focusout', onFocusOut);
      document.removeEventListener('pointerdown', onPointerDown, true);
      detachPointerEnd();
    },
  };
}

function getHeaderHeight() {
  return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
}

// Converte i link YouTube (youtu.be, watch?v=, shorts, embed, id nudo) in URL embed incorporabili.
function toEmbedUrl(urlOrId) {
  if (!urlOrId) return '';

  let id = '';
  const shorts = urlOrId.match(/youtube\.com\/shorts\/([^/?#&]+)/);
  const short = urlOrId.match(/youtu\.be\/([^/?#&]+)/);
  const watch = urlOrId.match(/[?&]v=([^?#&]+)/);
  const embed = urlOrId.match(/youtube\.com\/embed\/([^/?#&]+)/);

  if (shorts) {
    id = shorts[1];
  } else if (short) {
    id = short[1];
  } else if (watch) {
    id = watch[1];
  } else if (embed) {
    return urlOrId;
  } else if (/^[\w-]{6,}$/.test(urlOrId)) {
    return 'https://www.youtube.com/embed/' + urlOrId;
  } else {
    return urlOrId;
  }

  return 'https://www.youtube.com/embed/' + id;
}

// Istanzia/distrugge uno Swiper in base a una condizione ricalcolata a ogni resize
// (tipicamente: slide sufficienti per il breakpoint corrente). Gestisce anche la
// classe 'no-swiper' sul carousel e, salvo opt-out, la visibilità dei bottoni prev/next.
function createResponsiveCarousel(carousel, swiperSelector, shouldInit, swiperOptions, options) {
  options = options || {};
  const toggleNavButtons = options.toggleNavButtons !== false;
  const swiperEl = carousel.querySelector(swiperSelector);
  const prevBtnContainer = carousel.querySelector('.carousel-prev-btn-container');
  const nextBtnContainer = carousel.querySelector('.carousel-next-btn-container');
  let swiperInstance = null;

  function initSwiper() {
    if (swiperInstance) return;
    carousel.classList.remove('no-swiper');
    if (toggleNavButtons) {
      if (prevBtnContainer) prevBtnContainer.classList.remove('hidden');
      if (nextBtnContainer) nextBtnContainer.classList.remove('hidden');
    }
    swiperInstance = new Swiper(swiperEl, Object.assign({
      keyboard: { enabled: true, onlyInViewport: true },
    }, swiperOptions));
  }

  function destroySwiper() {
    if (!swiperInstance) {
      carousel.classList.add('no-swiper');
      return;
    }
    swiperInstance.destroy(true, true);
    swiperInstance = null;
    carousel.classList.add('no-swiper');
    if (toggleNavButtons) {
      if (prevBtnContainer) prevBtnContainer.classList.add('hidden');
      if (nextBtnContainer) nextBtnContainer.classList.add('hidden');
    }
  }

  function handleResize() {
    if (shouldInit()) {
      initSwiper();
    } else {
      destroySwiper();
    }
  }

  handleResize();
  window.addEventListener('resize', handleResize);

  return {
    get instance() { return swiperInstance; },
  };
}

// Rileva se i bottoni dei tab overflowano lo spazio disponibile e ritorna la funzione
// di update (tocca a chi chiama decidere quando agganciarla: resize, DOMContentLoaded...).
function createTabsOverflowUpdater(tabsBtns, tabsBtnsInner) {
  return function update() {
    const padding = window.innerWidth >= 768 ? 32 : 16;
    const totalWidth = tabsBtnsInner.scrollWidth;
    const available = window.innerWidth - padding * 2;
    tabsBtns.classList.toggle('is-overflow', totalWidth > available);
  };
}

// Drag-to-scroll orizzontale per contenitori con overflow-x nascosto (scrollbar assente).
// Abilitato solo su puntatori "fine" (mouse/trackpad): su touch lo swipe nativo basta già.
// Isolato dal resto: non tocca lo scroll-behavior se non durante il drag, poi lo ripristina.
function enableDragToScroll(scrollEl) {
  if (!scrollEl) return function () { };

  const finePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  if (!finePointer) return function () { };

  const DRAG_THRESHOLD = 5; // px minimi prima di considerare l'azione un drag (non un click).
  let isPointerDown = false;
  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;
  let previousScrollBehavior = '';

  scrollEl.classList.add('is-draggable');

  function onMouseDown(e) {
    if (e.button !== 0) return; // solo tasto sinistro
    isPointerDown = true;
    isDragging = false;
    startX = e.pageX;
    startScrollLeft = scrollEl.scrollLeft;
  }

  function onMouseMove(e) {
    if (!isPointerDown) return;
    const dx = e.pageX - startX;

    if (!isDragging) {
      if (Math.abs(dx) < DRAG_THRESHOLD) return; // sotto soglia: resta un potenziale click
      isDragging = true;
      scrollEl.classList.add('is-dragging');
      // Disabilita temporaneamente lo smooth scroll per un trascinamento reattivo.
      previousScrollBehavior = scrollEl.style.scrollBehavior;
      scrollEl.style.scrollBehavior = 'auto';
    }

    e.preventDefault(); // evita la selezione del testo durante il drag
    scrollEl.scrollLeft = startScrollLeft - dx;
  }

  function endDrag() {
    if (!isPointerDown) return;
    isPointerDown = false;
    if (isDragging) {
      scrollEl.classList.remove('is-dragging');
      // Ripristina lo scroll-behavior originale (es. smooth impostato via CSS).
      scrollEl.style.scrollBehavior = previousScrollBehavior;
      // Reset differito: mantiene isDragging=true per il click immediatamente successivo
      // così da poterlo sopprimere e non attivare il tab su cui si rilascia.
      window.setTimeout(function () { isDragging = false; }, 0);
    }
  }

  function onClickCapture(e) {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  scrollEl.addEventListener('mousedown', onMouseDown);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', endDrag);
  scrollEl.addEventListener('mouseleave', endDrag);
  scrollEl.addEventListener('click', onClickCapture, true);

  return function cleanup() {
    scrollEl.classList.remove('is-draggable', 'is-dragging');
    scrollEl.removeEventListener('mousedown', onMouseDown);
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', endDrag);
    scrollEl.removeEventListener('mouseleave', endDrag);
    scrollEl.removeEventListener('click', onClickCapture, true);
  };
}

// Click su un tab-btn -> attiva quel bottone e il pannello con lo stesso indice,
// disattivando gli altri. Ritorna setActive (il chiamante decide se forzare uno stato iniziale).
function createSimpleTabs(tabButtons, panels) {
  const tabsList = tabButtons.length ? tabButtons[0].parentElement : null;
  if (tabsList) tabsList.setAttribute('role', 'tablist');

  tabButtons.forEach(function (button, i) {
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-selected', 'false');
    button.setAttribute('tabindex', i === 0 ? '0' : '-1');
  });
  panels.forEach(function (p) {
    p.setAttribute('role', 'tabpanel');
  });

  function setActive(index) {
    tabButtons.forEach(function (b, i) {
      const isActive = i === index;
      b.classList.toggle('active', isActive);
      b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      b.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    panels.forEach(function (p, i) { p.classList.toggle('active', i === index); });
  }

  tabButtons.forEach(function (button, index) {
    button.addEventListener('click', function () {
      setActive(index);
    });
    button.addEventListener('keydown', function (e) {
      const count = tabButtons.length;
      let target = null;
      if (e.key === 'ArrowRight') target = (index + 1) % count;
      else if (e.key === 'ArrowLeft') target = (index - 1 + count) % count;
      else if (e.key === 'Home') target = 0;
      else if (e.key === 'End') target = count - 1;
      if (target === null) return;
      e.preventDefault();
      setActive(target);
      tabButtons[target].focus();
    });
  });

  return setActive;
}

// Accordion singolo che anima height 0<->auto via GSAP al click dell'header, alternando
// la classe 'open' sull'elemento indicato (openTarget può essere l'header stesso o un suo
// antenato, a seconda del modulo). getContent viene richiamata a ogni click (non cachata),
// per restare fedele al comportamento originale nel caso il contenuto venga sostituito.
function bindGsapHeightAccordion(header, getContent, openTarget) {
  header.setAttribute('role', 'button');
  header.setAttribute('tabindex', '0');
  header.setAttribute('aria-expanded', 'false');

  function toggle() {
    const content = getContent();
    if (!content) return;
    const isOpen = openTarget.classList.contains('open');
    if (isOpen) {
      openTarget.classList.remove('open');
      header.setAttribute('aria-expanded', 'false');
      gsap.to(content, { height: 0, duration: 0.25, ease: 'ease.linear' });
    } else {
      openTarget.classList.add('open');
      header.setAttribute('aria-expanded', 'true');
      gsap.to(content, { height: 'auto', duration: 0.25, ease: 'ease.linear' });
    }
  }

  header.addEventListener('click', toggle);
  header.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggle();
    }
  });
}

// Anima le "lions" SVG in scroll: partono scalate/traslate e rientrano a scale/yPercent
// naturali mentre il trigger attraversa lo scroll. tabletYPercent è l'unico valore che
// varia tra i moduli che la usano (60 o 40).
function animateLions(lions, options) {
  options = options || {};
  const tabletYPercent = options.tabletYPercent !== undefined ? options.tabletYPercent : 60;
  const mask = options.mask || null;
  const trigger = options.trigger || null;

  function getLionAnimationValues() {
    const width = window.innerWidth;
    if (width < 768) return { scale: 1.95, yPercent: 60 };
    if (width < 1024) return { scale: 1.45, yPercent: tabletYPercent };
    return { scale: 1.95, yPercent: 20 };
  }

  if (!lions.length) return;

  const lionValues = getLionAnimationValues();
  const sharedScrollTrigger = {
    start: 'clamp(top bottom-=10%)',
    end: 'clamp(bottom bottom-=55%)',
    scrub: true,
  };

  let baseHeight = 0;
  if (mask) {
    gsap.set(lions, { scale: 1, yPercent: 0, transformOrigin: 'center top' });
    const lionsContainer = mask.querySelector('.lions');
    baseHeight = lionsContainer ? lionsContainer.offsetHeight : 0;
  }

  lions.forEach(function (lion) {
    gsap.set(lion, {
      scale: lionValues.scale,
      yPercent: lionValues.yPercent,
      transformOrigin: mask ? 'center top' : undefined,
    });
  });

  if (mask && baseHeight) {
    const initialHeight = baseHeight * (lionValues.scale + lionValues.yPercent / 100);
    gsap.set(mask, { height: initialHeight });
    gsap.to(mask, {
      height: baseHeight,
      scrollTrigger: Object.assign({ trigger: trigger || lions[0] }, sharedScrollTrigger),
    });
  }

  lions.forEach(function (lion) {
    gsap.to(lion, {
      scale: 1,
      yPercent: 0,
      scrollTrigger: mask
        ? Object.assign({ trigger: trigger || lions[0] }, sharedScrollTrigger)
        : Object.assign({ trigger: lion }, sharedScrollTrigger),
    });
  });
}

// Crea un controller per un blocco '.overlay-modal-video': centralizza il reset dei
// media (video/iframe) e l'apertura/chiusura della modale via classe 'active'.
// options.video: l'elemento <video>, se presente, riceve anche reset di is-portrait/
// is-landscape + pause/load. options.onOpen/onClose: hook per effetti collaterali
// specifici del modulo chiamante (es. lock dello scroll del body).
// Rende un elemento non-nativo (div, ecc.) attivabile da tastiera: aggiunge
// role/tabindex se mancanti e simula un click su Enter/Spazio.
function makeKeyboardActivatable(el) {
  if (!el || el.tagName === 'BUTTON' || el.tagName === 'A') return;
  if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
  if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
  el.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      el.click();
    }
  });
}

// Raccoglie tutti gli elementi "fratelli" di ogni antenato di el fino a <body>
// (cioè: tutto ciò che NON è un antenato di el). Usato per nascondere lo sfondo
// della pagina alla assistive technology mentre una modale è aperta.
function getOutsideSiblings(el) {
  const result = [];
  let node = el;
  while (node && node !== document.body) {
    const parent = node.parentElement;
    if (parent) {
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling !== node) result.push(sibling);
      });
    }
    node = parent;
  }
  return result;
}

function createVideoModalController(overlayModalVideo, mediaEls, options) {
  options = options || {};
  const mediaVideo = options.video || null;
  let triggerEl = null;

  function getFocusable() {
    return Array.prototype.filter.call(
      overlayModalVideo.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input, select, textarea, iframe, video'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      closeModal();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusable = getFocusable();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function setBackgroundHidden(hidden) {
    getOutsideSiblings(overlayModalVideo).forEach(function (el) {
      if (hidden) {
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
      }
    });
  }

  function resetMedia() {
    mediaEls.forEach(function (el) {
      if (!el) return;
      el.classList.remove('is-active');
      el.setAttribute('src', '');
    });
    if (mediaVideo) {
      mediaVideo.classList.remove('is-portrait', 'is-landscape');
      mediaVideo.pause();
      mediaVideo.load();
    }
  }

  function closeModal() {
    overlayModalVideo.classList.remove('active');
    document.removeEventListener('keydown', handleKeydown);
    setBackgroundHidden(false);
    overlayModalVideo.setAttribute('inert', '');
    overlayModalVideo.setAttribute('aria-hidden', 'true');
    resetMedia();
    if (options.onClose) options.onClose();
    if (triggerEl && typeof triggerEl.focus === 'function') triggerEl.focus();
    triggerEl = null;
  }

  function openModal(trigger) {
    triggerEl = trigger || document.activeElement;
    overlayModalVideo.removeAttribute('inert');
    overlayModalVideo.removeAttribute('aria-hidden');
    overlayModalVideo.classList.add('active');
    setBackgroundHidden(true);
    document.addEventListener('keydown', handleKeydown);
    if (options.onOpen) options.onOpen();
    const focusable = getFocusable();
    if (focusable.length) {
      focusable[0].focus();
    } else {
      overlayModalVideo.focus();
    }
  }

  return { resetMedia: resetMedia, closeModal: closeModal, openModal: openModal };
}

// Riproduce un video/iframe YouTube dietro un poster-overlay, nascondendo il poster
// (e mostrandolo di nuovo a fine video/pausa).
function playPosterMedia(posterOverlay, wrapper) {
  const video = wrapper.querySelector('video');
  const iframe = wrapper.querySelector('iframe');

  posterOverlay.classList.add('hidden');

  if (video) {
    video.play();
    video.addEventListener('ended', function () {
      posterOverlay.classList.remove('hidden');
    }, { once: true });
  } else if (iframe) {
    iframe.contentWindow.postMessage(JSON.stringify({
      event: 'command',
      func: 'playVideo',
      args: []
    }), '*');
  }
}

// Mette in pausa il video/iframe di una slide e rimostra il suo poster-overlay.
function pausePosterMedia(slide) {
  if (!slide) return;
  const video = slide.querySelector('video');
  const iframe = slide.querySelector('iframe');
  const posterOverlay = slide.querySelector('.poster-overlay');

  if (video && !video.paused) {
    video.pause();
  }
  if (iframe) {
    iframe.contentWindow.postMessage(JSON.stringify({
      event: 'command',
      func: 'pauseVideo',
      args: []
    }), '*');
  }
  if (posterOverlay) {
    posterOverlay.classList.remove('hidden');
  }
}

// ============================================================

// hero parallax
// document.querySelectorAll(
//   '.hero-impact-full .wrap'
// ).forEach(function (wrap) {
//   var bg = wrap.querySelector('.background-image') || wrap.querySelector('.background-video');
//   if (!bg) return;

//   gsap.to(bg, {
//     yPercent: 60,
//     ease: 'none',
//     scrollTrigger: {
//       trigger: wrap,
//       start: 'top top',
//       end: 'bottom top',
//       scrub: true,
//     }
//   });
// });

//footer 
const footer = document.querySelector('.footer');
if (footer && footer.classList.contains('negative-margin')) {
  const footerCurve = footer.querySelector('.curve');
  if (footerCurve) {
    const setFooterMargin = () => {
      const footerCurveHeight = footerCurve.offsetHeight;
      if (footerCurveHeight > 0) {
        footer.style.marginTop = '-' + footerCurveHeight + 'px';
      }
    };

    if (footerCurve.complete && footerCurve.naturalHeight !== 0) {
      setFooterMargin();
    } else {
      footerCurve.addEventListener('load', setFooterMargin);
    }

    window.addEventListener('resize', setFooterMargin);
  }
}

//accordion simple
const accordionSimple = document.querySelectorAll('.accordion-simple .accordion-items .item');
if (accordionSimple.length > 0) {
  accordionSimple.forEach(function (item) {
    initAccordionBasic(item, accordionSimple);
  });
}


//accordion focus
const accordionFocus = document.querySelectorAll('.module-focus .accordion-items .item');
if (accordionFocus.length > 0 && window.matchMedia('(max-width: 1023px)').matches) {
  accordionFocus.forEach(function (item) {
    initAccordionBasic(item, accordionFocus);
  });
}

//accordion comparision
const accordionComparision = document.querySelectorAll('.accordion-comparision .items-group .item');
if (accordionComparision.length > 0) {
  accordionComparision.forEach(function (item) {
    initAccordionBasic(item, accordionComparision, true);
  });
}

//accordion basic logic
function initAccordionBasic(item, accordionItems, isAccordionComparision) {
  const header = item.querySelector('.item-header');
  const content = item.querySelector('.item-content');

  header.setAttribute('role', 'button');
  header.setAttribute('tabindex', '0');
  header.setAttribute('aria-expanded', 'false');

  function toggle() {
    const isOpen = item.classList.contains('open');
    if (isOpen) {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.offsetHeight;
      content.style.maxHeight = '0';
      item.classList.remove('open');
      header.setAttribute('aria-expanded', 'false');
    } else {
      accordionItems.forEach(function (otherItem) {
        if (otherItem !== item && otherItem.classList.contains('open') && !isAccordionComparision) {
          const otherContent = otherItem.querySelector('.item-content');
          const otherHeader = otherItem.querySelector('.item-header');
          otherContent.style.maxHeight = otherContent.scrollHeight + 'px';
          otherContent.offsetHeight;
          otherContent.style.maxHeight = '0';
          otherItem.classList.remove('open');
          if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false');
        }
      });

      item.classList.add('open');
      header.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    content.addEventListener('transitionend', function refreshOnce() {
      ScrollTrigger.refresh();
      content.removeEventListener('transitionend', refreshOnce);
    });
  }

  header.addEventListener('click', toggle);
  header.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggle();
    }
  });
}


//carousel recipe
const carouselRecipe = document.querySelectorAll('.carousel-recipe');
if (carouselRecipe.length > 0) {
  carouselRecipe.forEach(function (carousel) {
    const swiper = new Swiper('.swiper-recipe', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: false,
      loop: false,
      pagination: {
        el: '.carousel-pagination-recipe',
        clickable: true,
      },
      speed: 500,
      effect: 'slide',
      slidesOffsetAfter: 0,
      effectOptions: {
        slideShadows: false,
      },
      breakpoints: {
        0: {
          slidesPerView: "auto",
        },
        768: {
          slidesPerView: "auto",
        },
        1024: {
          slidesPerView: "auto",
        },
      },
    });
  });
}

//carousel DAY
const carouselDAY = document.querySelectorAll('.carousel-day');
if (carouselDAY.length > 0) {
  carouselDAY.forEach(function (carousel) {
    const swiper = new Swiper('.swiper-day', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: false,
      loop: false,
      pagination: {
        el: '.carousel-pagination-day',
        clickable: true,
      },
      speed: 500,
      effect: 'slide',
      slidesOffsetAfter: 0,
      effectOptions: {
        slideShadows: false,
      },
      breakpoints: {
        0: {
          slidesPerView: "auto",
        },
        768: {
          slidesPerView: "auto",
        },
        1024: {
          slidesPerView: "auto",
        },
      },
    });
  });
}

//carousel product
const carouselProduct = document.querySelectorAll('.carousel-product');
if (carouselProduct.length > 0) {
  carouselProduct.forEach(function (carousel) {
    var slideCount = carousel.querySelectorAll('.swiper-slide').length;

    function getMinSlides() {
      var w = window.innerWidth;
      if (w >= 1024) return 4;
      if (w >= 768) return 3;
      return 2;
    }

    createResponsiveCarousel(carousel, '.swiper-product', function () {
      return slideCount >= getMinSlides();
    }, {
      grabCursor: true,
      spaceBetween: 20,
      centeredSlides: false,
      loop: false,
      pagination: {
        el: carousel.querySelector('.carousel-pagination-product'),
        clickable: true,
      },
      navigation: {
        nextEl: carousel.querySelector('.carousel-next-btn'),
        prevEl: carousel.querySelector('.carousel-prev-btn'),
        disabledClass: 'disabled',
      },
      speed: 500,
      breakpoints: {
        0: {
          slidesPerView: 1,
          pagination: {
            el: carousel.querySelector('.carousel-pagination-product'),
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 3
          },
        },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3, dynamicBullets: false },
      },
    });
  });
}


//carousel product essentials
const carouselProductEssentials = document.querySelectorAll('.carousel-product-essentials');
if (carouselProductEssentials.length > 0) {
  carouselProductEssentials.forEach(function (carousel) {
    var swiperEl = carousel.querySelector('.swiper-product-essentials');
    var slideCount = carousel.querySelectorAll('.swiper-slide').length;

    gsap.matchMedia().add('(min-width: 1024px)', function () {
      gsap.from(swiperEl, {
        yPercent: 20,
        scrollTrigger: {
          trigger: swiperEl,
          start: 'top bottom',
          end: 'top center',
          scrub: true,
        }
      });
    });

    function shouldInitSwiper() {
      var w = window.innerWidth;
      if (w >= 1024) return false;
      if (w >= 768) return slideCount > 2;
      return slideCount > 1;
    }

    createResponsiveCarousel(carousel, '.swiper-product-essentials', shouldInitSwiper, {
      grabCursor: true,
      spaceBetween: 20,
      centeredSlides: false,
      loop: false,
      pagination: {
        el: carousel.querySelector('.carousel-pagination-product'),
        clickable: true,
      },
      navigation: {
        nextEl: carousel.querySelector('.carousel-next-btn'),
        prevEl: carousel.querySelector('.carousel-prev-btn'),
        disabledClass: 'disabled',
      },
      speed: 500,
      breakpoints: {
        0: { slidesPerView: 1, },
        768: { slidesPerView: 2 },
      },
    });
  });
}

//card compare simple
const cardCompareSimple = document.querySelectorAll('.card-compare');
if (cardCompareSimple.length > 0) {
  // Su touch il video parte al tap e si ferma al secondo tap. Le due logiche sono
  // esclusive perché al tap i browser touch emulano anche mouseenter: l'hover
  // avvierebbe il video subito prima del click e il toggle lo rimetterebbe in pausa.
  const isTouchCompare = window.matchMedia('(hover: none)').matches;
  const touchVideoCards = [];

  const stopCompareVideo = (card) => {
    const video = card.querySelector('video');
    if (video && !video.paused) video.pause();
    card.classList.remove('is-playing');
  };

  cardCompareSimple.forEach(function (card) {
    const video = card.querySelector('video');
    if (video) {
      video.muted = true;
      if (isTouchCompare) {
        if (card.classList.contains('is-video')) touchVideoCards.push(card);
        return;
      }
      card.addEventListener('mouseenter', function () {
        video.play();
      });

      card.addEventListener('mouseleave', function () {
        video.pause();
        setTimeout(function () { video.currentTime = 0; }, 150);

      });
    }
  });

  if (touchVideoCards.length > 0) {
    const compareVideoObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) stopCompareVideo(entry.target);
        });
      })
      : null;

    touchVideoCards.forEach(function (card) {
      const video = card.querySelector('video');

      // Listener su tutta la card: .product copre .background. La CTA deve
      // navigare normalmente; defaultPrevented copre il click che Swiper
      // annulla dopo un drag del carosello.
      card.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        if (e.defaultPrevented) return;

        if (!video.paused) {
          stopCompareVideo(card);
          return;
        }

        touchVideoCards.forEach(function (other) {
          if (other !== card) stopCompareVideo(other);
        });
        card.classList.add('is-playing');
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            card.classList.remove('is-playing');
          });
        }
      });

      if (compareVideoObserver) compareVideoObserver.observe(card);
    });
  }
}


// carousel compare
const carouselCompare = document.querySelectorAll('.carousel-compare');
if (carouselCompare.length > 0) {
  carouselCompare.forEach(function (carousel) {
    var slideCount = carousel.querySelectorAll('.swiper-slide').length;

    function shouldInitSwiper() {
      var w = window.innerWidth;
      if (w >= 1024) return slideCount > 3;
      if (w >= 768) return slideCount > 2;
      return slideCount > 1;
    }

    createResponsiveCarousel(carousel, '.swiper-compare', shouldInitSwiper, {
      grabCursor: true,
      spaceBetween: 32,
      centeredSlides: false,
      loop: false,
      pagination: {
        el: carousel.querySelector('.carousel-pagination-compare'),
        clickable: true,
      },
      navigation: {
        nextEl: carousel.querySelector('.carousel-next-btn'),
        prevEl: carousel.querySelector('.carousel-prev-btn'),
        disabledClass: 'disabled',
      },
      speed: 500,
      breakpoints: {
        0: {
          slidesPerView: 1.3, spaceBetween: 16,
          pagination: {

            dynamicBullets: true,
            dynamicMainBullets: 3
          },
        },
        768: {
          slidesPerView: 2.3, spaceBetween: 24,
          pagination: {
            dynamicBullets: false,
            dynamicMainBullets: 3
          },
        },
        1024: { slidesPerView: 3, spaceBetween: 24 },
        1440: { slidesPerView: 3, spaceBetween: 32 },
      },
    });
  });
}

//carousel compare essentials
const carouselCompareEssentials = document.querySelectorAll('.carousel-compare-essentials');
if (carouselCompareEssentials.length > 0) {
  carouselCompareEssentials.forEach(function (carousel) {
    const carouselBtns = carousel.querySelectorAll('.carousel-btns');

    if (window.matchMedia('(min-width: 1024px)').matches) {
      carouselBtns.forEach(function (btn) {
        btn.style.display = 'none';
      });
    }

    const swiper = new Swiper('.swiper-compare-essentials', {
      grabCursor: true,
      slidesPerView: 4,
      spaceBetween: 32,
      centeredSlides: false,
      loop: false,
      pagination: {
        el: '.carousel-pagination-compare-essentials',
        clickable: true,
      },
      navigation: {
        nextEl: '.carousel-next-btn',
        prevEl: '.carousel-prev-btn',
        disabledClass: 'disabled',
      },
      speed: 500,
      effect: 'slide',
      effectOptions: {
        slideShadows: false,
      },
      breakpoints: {
        0: { slidesPerView: 1.3, spaceBetween: 16 },
        768: { slidesPerView: 2.3, spaceBetween: 24 },
        1024: { slidesPerView: 4, spaceBetween: 24 },
        1440: { slidesPerView: 4, spaceBetween: 32 },
      },
    });
  });
}

//module highlight slider

const moduleHighlightSlider = document.querySelectorAll('.module-highlight-slider');
if (moduleHighlightSlider.length > 0) {

  let currentSlideIndex = 0;

  const buttons = document.querySelectorAll('.module-highlight-slider .button-index');

  function updateButtonStates() {
    buttons.forEach((button, index) => {
      const isActive = index === currentSlideIndex;
      button.classList.toggle('active', isActive);
      if (isActive) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  }

  function goToSlide(slideIndex, options = {}) {
    const skipSwiperUpdate = options.skipSwiperUpdate || false;

    currentSlideIndex = slideIndex;

    if (!skipSwiperUpdate) {
      swiperHighlightSliderImages.slideToLoop(slideIndex);
    }

    updateButtonStates();
  }

  function onHighlightSliderSlideChange() {
    const index = this.realIndex;
    if (index === currentSlideIndex) return;
    goToSlide(index, { skipSwiperUpdate: true });
  }

  const swiperHighlightSliderTouchHandlers = {
    slideChange: onHighlightSliderSlideChange,
  };

  // Prima inizializza lo slider dei testi
  const swiperHighlightSliderTexts = new Swiper('.swiper-highlight-slider__texts', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    speed: 800,
    effect: 'slide',
    effectOptions: {
      slideShadows: false,
    },
    allowTouchMove: true,
    grabCursor: true,
    on: swiperHighlightSliderTouchHandlers,
  });

  // Poi inizializza lo slider delle immagini
  const swiperHighlightSliderImages = new Swiper('.swiper-highlight-slider__images', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    speed: 800,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    effectOptions: {
      slideShadows: false,
    },
    allowTouchMove: true,
    grabCursor: true,
    navigation: {
      nextEl: '.highlight-next-btn',
      prevEl: '.highlight-prev-btn',
      disabledClass: 'disabled',
    },
    pagination: {
      el: '.carousel-pagination-highlight',
      clickable: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Slide precedente',
      nextSlideMessage: 'Slide successiva',
      paginationBulletMessage: 'Vai alla slide {{index}}',
      slideLabelMessage: '{{index}} di {{slidesLength}}',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
    },
    on: swiperHighlightSliderTouchHandlers,
  });

  // Sincronizza entrambi gli swiper durante lo swipe (nessun delay)
  swiperHighlightSliderImages.controller.control = swiperHighlightSliderTexts;
  swiperHighlightSliderTexts.controller.control = swiperHighlightSliderImages;

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      goToSlide(index);
    });
  });

  goToSlide(0);

}

//module circle highlight
const moduleCircleHighlight = document.querySelectorAll('.module-circle-highlight');

if (moduleCircleHighlight.length > 0) {
  moduleCircleHighlight.forEach(function (module) {
    const controlsButtons = module.querySelectorAll('.controls-button');
    const arcStart = -controlsButtons.length * 10;
    const arcEnd = controlsButtons.length * 10;
    const total = controlsButtons.length;
    const controlsItems = module.querySelectorAll('.controls-items-wrapper .control-item');
    const contentItems = module.querySelector('.items-content-slider');
    const contentItemsSlides = contentItems.querySelectorAll('.item-content');
    const swiperEl = module.querySelector('.swiper-circle-highlight');
    let currentSlideIndex = 0;
    let swiperInstance = null;

    // set all svg progress to 0
    const radius = 23;
    const circumference = 2 * Math.PI * radius;
    const timerIcons = module.querySelectorAll('.control-timer');
    timerIcons.forEach(function (timerIcon) {
      timerIcon.style.strokeDasharray = `${circumference} ${circumference}`;
      timerIcon.style.strokeDashoffset = circumference;
    });

    // position the control buttons along the arc
    controlsButtons.forEach(function (btn, i) {
      const angle = total === 1
        ? (arcStart + arcEnd) / 2
        : arcStart + (arcEnd - arcStart) * (i / (total - 1))

      const rad = angle * (Math.PI / 180)

      btn.style.left = `${50 + 50 * Math.cos(rad)}%`
      btn.style.top = `${50 + 50 * Math.sin(rad)}%`

      // a click drives the active slide in both modes
      btn.addEventListener('click', function () {
        if (swiperInstance) {
          swiperInstance.slideToLoop(i);
        } else {
          desktopGoTo(i);
        }
      });
    });

    function syncControls(index) {
      controlsItems.forEach(function (item, i) {
        item.classList.toggle('active', i === index);
      });
      timerIcons.forEach(function (icon, i) {
        gsap.killTweensOf(icon);
        gsap.set(icon, { strokeDashoffset: i === index ? 0 : circumference });
      });
      currentSlideIndex = index;
    }

    // ---- DESKTOP MODE: custom carousel driven by slide classes ----
    function desktopGoTo(index) {
      contentItemsSlides.forEach(function (slide, i) {
        slide.classList.toggle('swiper-slide-active', i === index);
      });
      syncControls(index);
    }

    function enableDesktop() {
      desktopGoTo(currentSlideIndex);
    }

    // ---- MOBILE MODE: Swiper drives the slides ----
    function enableMobile() {
      contentItems.style.transform = '';

      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 800,
        effect: 'slide',
        initialSlide: currentSlideIndex,
        on: {
          slideChange: function () {
            syncControls(this.realIndex);
          },
          afterInit: function () {
            syncControls(this.realIndex);
          },
        },
      });
    }

    function disableMobile() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    // switch mode based on viewport width
    function setMode() {
      const isMobile = window.innerWidth < 768;
      if (isMobile && !swiperInstance) {
        enableMobile();
      } else if (!isMobile && swiperInstance) {
        disableMobile();
        enableDesktop();
      }
    }

    // first paint
    if (window.innerWidth < 768) {
      enableMobile();
    } else {
      enableDesktop();
    }

    window.addEventListener('resize', setMode);
  });
}





// hero video scroll
const heroVideoScroll = document.querySelectorAll('.hero-video-scroll');
if (heroVideoScroll.length > 0) {
  heroVideoScroll.forEach(function (hero) {
    const videoWrapper = hero.querySelector('.video-wrapper');
    const video = videoWrapper.querySelector('video');

    video.preload = 'auto';
    video.playsInline = true;
    video.muted = true;
    video.volume = 0;

    const mm = gsap.matchMedia();
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    let lastUpdateTime = 0;
    let lastProgress = -1;
    let isUpdating = false;
    let iosInitialized = false;

    const updateVideoFrame = (targetTime) => {
      if (Math.abs(video.currentTime - targetTime) < 0.1) {
        isUpdating = false;
        return;
      }

      video.currentTime = targetTime;

      if (isIOS) {
        requestAnimationFrame(() => {
          isUpdating = false;
        });
      } else {
        isUpdating = false;
      }
    };

    const onUpdate = function (self) {
      if (isUpdating) return;

      const now = Date.now();
      const targetTime = self.progress * video.duration;

      if (now - lastUpdateTime < 33) return;
      if (Math.abs(self.progress - lastProgress) < 0.01) return;

      lastUpdateTime = now;
      lastProgress = self.progress;
      isUpdating = true;

      updateVideoFrame(targetTime);
    };

    const initScrollTrigger = () => {
      mm.add('(min-width: 1024px)', () => {
        const st = ScrollTrigger.create({
          trigger: videoWrapper,
          start: 'center center',
          end: '+=160%',
          scrub: 1,
          pin: true,
          pinSpacing: true,
          // Pin più in alto nella pagina → priorità massima nel ricalcolo.
          refreshPriority: 2,
          onUpdate: onUpdate
        });
        return () => st.kill();
      });

      mm.add('(max-width: 1023px)', () => {
        var headerHeight = getHeaderHeight() + 'px';

        const st = ScrollTrigger.create({
          trigger: hero,
          start: 'top ' + headerHeight,
          end: '+=100%',
          scrub: 1,
          pin: true,
          pinSpacing: true,
          refreshPriority: 2,
          onUpdate: onUpdate
        });
        return () => st.kill();
      });

      ScrollTrigger.refresh();
    };

    const prepareVideo = () => {
      video.currentTime = 0;

      if (isIOS) {
        video.play().then(() => {
          setTimeout(() => {
            video.pause();
            video.currentTime = 0;
            iosInitialized = true;
            initScrollTrigger();
          }, 50);
        }).catch(() => {
          initScrollTrigger();
        });
      } else {
        video.pause();
        initScrollTrigger();
      }
    };

    if (video.readyState >= 1) {
      prepareVideo();
    } else {
      video.addEventListener('loadedmetadata', prepareVideo, { once: true });
    }
  });
}

//scroll down hero video scroll
const scrollDownHeroVideoScroll = document.querySelectorAll('.hero-video-scroll-scrolldown');
if (scrollDownHeroVideoScroll.length > 0) {
  scrollDownHeroVideoScroll.forEach(function (scrollDown) {
    const scrollDownHeight = scrollDown.offsetHeight + 32;
    gsap.to(scrollDown, {
      opacity: 0,
      scrollTrigger: {
        trigger: scrollDown,
        start: 'top bottom-=' + scrollDownHeight + 'px',
        end: 'bottom bottom-=' + scrollDownHeight + 'px',
        scrub: 1,
      }
    });
  });
}


// sticky scroll module
window.addEventListener('load', function () {
  ScrollTrigger.refresh();

  const stickyScrollModules = document.querySelectorAll('.module-scroll-sticky');
  if (stickyScrollModules.length > 0) {
    stickyScrollModules.forEach(function (section) {
      const labelsArea = section.querySelector('.labels-wrap');
      const labelsItems = labelsArea.querySelectorAll('.label-item');
      const swiperWrapper = section.querySelector('.swiper-wrapper');
      const swiperEl = section.querySelector('.swiper');
      const slides = section.querySelectorAll('.swiper-slide');
      let swiperInstance = null;

      ScrollTrigger.matchMedia({
        '(max-width: 1023px)': function () {
          swiperInstance = new Swiper(swiperEl, {
            slidesPerView: 1.25,
            spaceBetween: 16,
            grabCursor: true,
            loop: false,
            pagination: {
              el: section.querySelector('.carousel-pagination-bullets'),
              clickable: true,
            },
            breakpoints: {
              0: {
                slidesPerView: 1.25,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 2.25,
                spaceBetween: 16,
              },
            }
          });


          return function () {
            if (swiperInstance) {
              swiperInstance.destroy(true, true);
              swiperInstance = null;
            }
          };
        },
        '(min-width: 1024px)': function () {
          let mouseX = 0, mouseY = 0;

          function activateItem(index) {
            const currentActiveSlide = section.querySelector('.swiper-slide.active');
            const currentActiveLabel = section.querySelector('.label-item.active');
            if (currentActiveSlide) currentActiveSlide.classList.remove('active');
            if (currentActiveLabel) currentActiveLabel.classList.remove('active');
            slides[index].classList.add('active');
            labelsItems[index].classList.add('active');
          }

          slides[0].classList.add('active');
          labelsItems[0].classList.add('active');

          labelsItems.forEach(function (item, index) {
            item.addEventListener('mouseenter', function () {
              activateItem(index);
            });
          });

          function onMouseMove(e) {
            mouseX = e.clientX;
            mouseY = e.clientY;
          }

          function onScroll() {
            const el = document.elementFromPoint(mouseX, mouseY);
            if (!el) return;
            const label = el.closest('.label-item');
            if (!label || !labelsArea.contains(label)) return;
            const index = Array.prototype.indexOf.call(labelsItems, label);
            if (index !== -1) activateItem(index);
          }

          function syncHeight() {
            const slideHeight = slides[0] ? slides[0].offsetHeight : 0;
            if (slideHeight) section.style.minHeight = slideHeight + 'px';
          }

          syncHeight();

          document.addEventListener('mousemove', onMouseMove);
          window.addEventListener('scroll', onScroll);
          window.addEventListener('resize', syncHeight);

          return function () {
            document.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', syncHeight);
            section.style.minHeight = '';
          };
        }
      });
    });
  }
  //animation scroll zoom-in

  const bannerScrollZoomIn = document.querySelectorAll('.animation-scroll-zoom-in');
  if (bannerScrollZoomIn.length > 0) {
    bannerScrollZoomIn.forEach(function (banner) {
      const bannerImage = banner.querySelector('.background-image');

      gsap.to(bannerImage, {
        scale: 1.1,
        ease: 'easeInOut',
        duration: 1,
        scrollTrigger: {
          trigger: banner,
          start: 'top bottom',
          end: 'bottom bottom',
          scrub: 1,
        }
      });
    });
  }


  // animation-fixed-bg parallax
  document.querySelectorAll('.animation-fixed-bg .wrap').forEach(function (wrap) {
    var bg = wrap.querySelector('.background-image') || wrap.querySelector('.background-video');
    if (!bg) return;

    bg.style.willChange = 'transform';
    /*
    - lerp(currentY, targetY, 0.08) — il background "insegue" la posizione target con un'ammortizzazione continua: il valore 0.08 significa che ogni frame percorre l'8% della distanza rimasta → movimento esponenzialmente smorzato, mai a step
    - { passive: true } sul listener scroll — non blocca il thread principale, lo scroll rimane fluido
    - Il loop si ferma da solo quando currentY è a meno di 0.05px da targetY, evitando cicli inutili
    - strength: 0.3 controlla l'intensità del parallax (abbassalo per ridurlo, alzalo per aumentarlo)
    */
    var currentY = 0;
    var targetY = 0;
    var rafId = null;
    var section = wrap.closest('.animation-fixed-bg');
    var strength = section && section.dataset.parallaxStrength
      ? parseFloat(section.dataset.parallaxStrength)
      : 0.8;
    if (isNaN(strength)) strength = 0.8;
    var lerpFactor = 1;
    var SAFETY = 1.5; // px di margine extra per evitare gap sub-pixel

    function lerp(a, b, t) {
      return a + (b - a) * t;
    }

    // Dimensiona e posiziona il background così da coprire SEMPRE il container
    // lungo tutta l'escursione del parallax.
    // Escursione totale = strength * H → altezza necessaria = H * (1 + strength).
    // top = -tMax così il bordo alto copre y=0 anche alla massima traslazione verso il basso.
    function layoutBg() {
      var H = wrap.offsetHeight;
      var vh = window.innerHeight;
      var denom = H + vh;
      var tMax = strength * H * (H / denom);   // traslazione max (wrap esce in alto)
      var tMin = -strength * H * (vh / denom); // traslazione min (wrap entra dal basso)

      var top = -tMax - SAFETY;
      var height = H + (tMax - tMin) + SAFETY * 2;

      bg.style.position = 'absolute';
      bg.style.left = '0';
      bg.style.width = '100%';
      bg.style.top = top.toFixed(2) + 'px';
      bg.style.height = height.toFixed(2) + 'px';
      bg.style.opacity = '1';

      if (bg.tagName === 'IMG' || bg.tagName === 'VIDEO') {
        bg.style.objectFit = 'cover';
        bg.style.objectPosition = 'center';
      }
    }

    function tick() {
      currentY = lerp(currentY, targetY, lerpFactor);
      bg.style.transform = 'translate3d(0,' + currentY.toFixed(3) + 'px,0)';
      if (Math.abs(targetY - currentY) > 0.05) {
        rafId = requestAnimationFrame(tick);
      } else {
        rafId = null;
      }
    }

    function onScroll() {
      var rect = wrap.getBoundingClientRect();
      var progress = (-rect.top) / (rect.height + window.innerHeight);
      targetY = progress * rect.height * strength;
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    layoutBg();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      layoutBg();
      onScroll();
    });
    window.addEventListener('load', layoutBg);
    onScroll();
  });

});

// TRANSITION IN HERO //

const heroImpactFull = document.querySelectorAll('.hero-transition-in');
if (heroImpactFull.length > 0) {
  heroImpactFull.forEach(function (hero) {
    const splitElements = SplitText.create(hero.querySelectorAll('.split-hero-text'), {
      type: 'lines',
      linesClass: 'split-hero-text-line',
    });
    const ctaArea = hero.querySelector('.cta-area');
    const prodImage = hero.querySelector('.product-img');
    const imageArea = hero.querySelector('.image-container');
    console.log(splitElements);
    if (imageArea) {
      gsap.set(imageArea, {
        opacity: 0,
        y: window.innerWidth < 1024 ? 20 : 40,
      });
    }
    if (prodImage) {
      gsap.set(prodImage, {
        opacity: 0,
        y: window.innerWidth < 1024 ? 20 : 40,
      });
    }
    if (ctaArea) {
      gsap.set(ctaArea, {
        opacity: 0,
        y: window.innerWidth < 1024 ? 20 : 40,
      });
    }
    gsap.set(splitElements.lines, {
      opacity: 0,
      y: window.innerWidth < 1024 ? 20 : 40,
    });
    const tl = gsap.timeline({
      delay: 0.5,
    });

    tl
      .to(splitElements.lines, {
        y: 0,
        duration: 0.65,
        stagger: 0.0875,
        opacity: 1,
        ease: 'power2.out',
      })
      .to(splitElements.elements, {
        opacity: 1,
        duration: 0.65,
        stagger: 0.0875,
        ease: 'power2.out',
      }, 0)
    if (imageArea) {
      tl.to(imageArea, {
        opacity: 1,
        y: 0,
        duration: 0.65,
        ease: 'power2.out',
      });
    }
    if (ctaArea) {
      tl.to(ctaArea, {
        opacity: 1,
        y: 0,
        duration: 0.65,
        ease: 'power2.out',
      });
    }
    if (prodImage) {
      tl.to(prodImage, {
        opacity: 1,
        y: 0,
        duration: 0.65,
        ease: 'power2.out',
      });
      gsap.to(prodImage, {
        yPercent: -35,
        scrollTrigger: {
          trigger: prodImage,
          start: 'clamp(top center+=15%, 0px, bottom center+=15%)',
          end: 'clamp(bottom top, 100%, bottom top)',
          scrub: true,
        }
      });
    }

  })
}

// carousel big
const carouselBig = document.querySelectorAll('.carousel-big');
if (carouselBig.length > 0) {
  carouselBig.forEach(function (carousel) {
    const swiper = new Swiper('.swiper-big', {
      slidesPerView: 1.25,
      spaceBetween: 32,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.carousel-pagination-big',
        clickable: true,
      },
      breakpoints: {
        0: {
          spaceBetween: 16,
        },
        768: {

          spaceBetween: 24,
        },
        1440: {

          spaceBetween: 32,
        },
      }
    });
  });
}

//hero slider
const heroSlider = document.querySelectorAll('.hero-slider');
if (heroSlider.length > 0) {
  heroSlider.forEach(function (hero) {
    const swiper = new Swiper('.swiper-hero-slider', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      speed: 500,
      effect: 'slide',
      pagination: {
        el: '.swiper-pagination-hero-slider',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: '.btn-hero-slider.btn-next',
        prevEl: '.btn-hero-slider.btn-prev',
        disabledClass: 'disabled',
      },
    });

    // Ferma l'autoplay quando un elemento dentro lo slider riceve focus da tastiera,
    // così chi naviga con Tab non si ritrova lo slide che cambia sotto le mani.
    const heroSliderEl = hero.querySelector('.swiper-hero-slider');
    if (heroSliderEl) {
      heroSliderEl.addEventListener('focusin', function () {
        if (swiper.autoplay) swiper.autoplay.stop();
      });
      heroSliderEl.addEventListener('focusout', function () {
        if (swiper.autoplay && !heroSliderEl.contains(document.activeElement)) {
          swiper.autoplay.start();
        }
      });
    }
  });
}

// chips group

const chipsGroup = document.querySelectorAll('.chips-group');
if (chipsGroup.length > 0) {
  chipsGroup.forEach(function (chips) {
    const chipsWrapper = chips.querySelectorAll('.chips-group-items');
    const chipsCta = chips.querySelector('.cta-wrap');
    const maxHeight = {
      '0': 214,
      '768': 122,
      '1024': 200,
      '1440': 150,
    }

    let currentMax = maxHeight['0'];

    function updateMaxHeight() {
      const width = window.innerWidth;
      const breakpoints = Object.keys(maxHeight).map(Number).sort((a, b) => b - a);
      currentMax = maxHeight[breakpoints.find(bp => width >= bp)] || maxHeight['0'];

      chipsWrapper.forEach(function (wrapper) {
        if (wrapper.scrollHeight > currentMax) {
          chips.classList.add('masked');
        } else {
          chips.classList.remove('masked');
        }
      });
    }

    chipsCta.addEventListener('click', function () {
      chips.classList.toggle('open');
    });

    updateMaxHeight();
    window.addEventListener('resize', updateMaxHeight);
  });
}

// module text mask
const moduleTextMask = document.querySelectorAll('.module-text-mask');
if (moduleTextMask.length > 0) {
  moduleTextMask.forEach(function (module) {
    const readMoreToggle = module.querySelector('.read-more-toggle');
    readMoreToggle.addEventListener('click', function () {
      module.classList.toggle('open');
    });
  });
}


// module scroll recipe
const moduleScrollRecipe = document.querySelectorAll('.module-scroll-recipe');
if (moduleScrollRecipe.length > 0) {
  moduleScrollRecipe.forEach(function (section) {
    const labelsArea = section.querySelector('.labels-wrap');
    const labelsItems = labelsArea.querySelectorAll('.label-item');
    const swiperEl = section.querySelector('.swiper');
    const slides = section.querySelectorAll('.swiper-slide');
    let swiperInstance = null;
    let mouseX = 0, mouseY = 0;

    const mq = window.matchMedia('(min-width: 1024px)');

    function activateItem(index) {
      slides.forEach(function (s) { s.classList.remove('active'); });
      labelsItems.forEach(function (l) { l.classList.remove('active'); });
      slides[index].classList.add('active');
      labelsItems[index].classList.add('active');
    }

    function onMouseMove(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
    }

    function onScroll() {
      const el = document.elementFromPoint(mouseX, mouseY);
      if (!el) return;
      const label = el.closest('.label-item');
      if (!label || !labelsArea.contains(label)) return;
      const index = Array.prototype.indexOf.call(labelsItems, label);
      if (index !== -1) activateItem(index);
    }

    function syncHeight() {
      const slideHeight = slides[0] ? slides[0].offsetHeight : 0;
      if (slideHeight) section.style.minHeight = slideHeight + 'px';
    }

    function initDesktop() {
      section.classList.add('is-desktop-mode');
      activateItem(0);
      labelsItems.forEach(function (item, index) {
        item.addEventListener('mouseenter', function () { activateItem(index); });
      });
      document.addEventListener('mousemove', onMouseMove);
      window.addEventListener('scroll', onScroll);
      window.addEventListener('resize', syncHeight);
      syncHeight();
    }

    function destroyDesktop() {
      section.classList.remove('is-desktop-mode');
      slides.forEach(function (s) { s.classList.remove('active'); });
      labelsItems.forEach(function (l) { l.classList.remove('active'); });
      document.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', syncHeight);
      section.style.minHeight = '';
    }

    function initMobile() {
      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1.25,
        spaceBetween: 16,
        grabCursor: true,
        loop: false,
        observer: true,
        observeParents: true,
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3
        },
        breakpoints: {
          768: {
            slidesPerView: 2.25,
            spaceBetween: 16,
          },
        },
      });
    }

    function destroyMobile() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    function onBreakpointChange(e) {
      if (e.matches) {
        destroyMobile();
        initDesktop();
      } else {
        destroyDesktop();
        initMobile();
      }
    }

    mq.addEventListener('change', onBreakpointChange);

    if (mq.matches) {
      initDesktop();
    } else {
      initMobile();
    }
  });
}

// module method list
const moduleMethodList = document.querySelectorAll('.module-method-list');
if (moduleMethodList.length > 0) {
  moduleMethodList.forEach(function (section) {
    const listItems = section.querySelectorAll('.list-item');
    listItems.forEach(function (item) {
      gsap.fromTo(item, { opacity: 0.35 }, {
        opacity: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: item,
          start: 'top 80%',
          end: 'top center',
          scrub: true,
        },
      });
    });
  });
}


// side today recipe
function parseSideTodayRecipeTime(timeStr) {
  if (!timeStr) return null;
  const match = String(timeStr).trim().match(/^(\d{1,2}):(\d{2})\s*(am|pm)$/i);
  if (!match) return null;

  let hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const period = match[3].toLowerCase();

  if (period === 'pm' && hours !== 12) hours += 12;
  if (period === 'am' && hours === 12) hours = 0;

  return hours * 60 + minutes;
}

function getActiveSideTodayRecipe(recipes) {
  if (!recipes.length) return null;

  const withTime = recipes
    .map((recipe) => ({ recipe, minutes: parseSideTodayRecipeTime(recipe.time) }))
    .filter((entry) => entry.minutes !== null)
    .sort((a, b) => a.minutes - b.minutes);

  if (!withTime.length) return recipes[0];

  const now = new Date();
  const nowMinutes = now.getHours() * 60 + now.getMinutes();
  let active = withTime[withTime.length - 1].recipe;

  withTime.forEach((entry) => {
    if (entry.minutes <= nowMinutes) {
      active = entry.recipe;
    }
  });

  return active;
}

function updateSideTodayRecipeClock(section) {
  const timeStamp = section.querySelector('.time');
  if (!timeStamp) return;

  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  const minutesPadded = String(minutes).padStart(2, '0');
  const dayNumber = timeStamp.querySelector('.day-number');
  const dayTime = timeStamp.querySelector('.day-time');

  if (dayNumber) dayNumber.textContent = `${String(hours12).padStart(2, '0')}:${minutesPadded}`;
  if (dayTime) dayTime.textContent = ampm;
}

function updateSideTodayRecipeContent(section, recipes) {
  const active = getActiveSideTodayRecipe(recipes);
  if (!active) return;

  const titleEl = section.querySelector('.text-wrap .title');
  const cta = section.querySelector('.text-wrap .cta');
  const imageWrap = section.querySelector('.image-wrap');
  const image = section.querySelector('.image-wrap img');

  if (titleEl) titleEl.textContent = active.title || '';
  if (cta) {
    cta.href = active.permalink || '#';
    cta.style.display = active.permalink ? '' : 'none';
  }

  if (imageWrap && image) {
    if (active.image?.url) {
      image.src = active.image.url;
      image.alt = active.image.alt || '';
      imageWrap.style.display = '';
    } else {
      image.removeAttribute('src');
      image.alt = '';
      imageWrap.style.display = 'none';
    }
  }
}

const sideTodayRecipe = document.querySelectorAll('.side-today-recipe');
if (sideTodayRecipe.length > 0) {
  sideTodayRecipe.forEach(function (section) {
    let recipes = [];

    try {
      recipes = JSON.parse(section.dataset.recipes || '[]');
    } catch (error) {
      recipes = [];
    }

    const cta = section.querySelector('.cta');
    const image = section.querySelector('.image-wrap img');

    const refresh = () => {
      updateSideTodayRecipeClock(section);
      updateSideTodayRecipeContent(section, recipes);
    };

    refresh();
    window.setInterval(refresh, 60000);

    if (cta && image) {
      cta.addEventListener('mouseenter', () => {
        gsap.to(image, { scale: 1.03, duration: 0.5, ease: 'power2.out' });
      });
      cta.addEventListener('mouseleave', () => {
        gsap.to(image, { scale: 1, duration: 0.5, ease: 'power2.out' });
      });
    }
  });
}

// carousel made with
const carouselMadeWith = document.querySelectorAll('.carousel-made-with');
if (carouselMadeWith.length > 0) {
  carouselMadeWith.forEach(function (carousel) {
    var slideCount = carousel.querySelectorAll('.swiper-slide').length;

    function getMinSlides() {
      return window.innerWidth >= 1024 ? 3 : 2;
    }

    createResponsiveCarousel(carousel, '.swiper-made-with', function () {
      return slideCount >= getMinSlides();
    }, {
      slidesPerView: 1,
      spaceBetween: 32,
      navigation: {
        nextEl: carousel.querySelector('.carousel-next-btn'),
        prevEl: carousel.querySelector('.carousel-prev-btn'),
        disabledClass: 'disabled',
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
      },
    }, { toggleNavButtons: false });
  });
}

// module tab ingredients
const moduleTabIngredients = document.querySelectorAll('.module-tab-ingredients');
if (moduleTabIngredients.length > 0) {
  moduleTabIngredients.forEach(function (wrapper) {
    var tabsWrap = wrapper.querySelector('.tabs-wrap');
    var tabsWrapHeight = tabsWrap ? tabsWrap.offsetHeight : 0;
    var ingredientsBtn = wrapper.querySelector('.ingredients-btn');
    var methodBtn = wrapper.querySelector('.method-btn');
    var ingredientsSection = wrapper.querySelector('.module-ingredients');
    var methodSection = wrapper.querySelector('.method-list-wrap');

    if (!ingredientsBtn || !methodBtn || !ingredientsSection || !methodSection) {
      return;
    }

    function verticalVisibleRatio(el) {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || 0;
      var visibleTop = Math.max(rect.top, 0);
      var visibleBottom = Math.min(rect.bottom, vh);
      var visibleHeight = Math.max(0, visibleBottom - visibleTop);
      return rect.height > 0 ? visibleHeight / rect.height : 0;
    }

    function updateTabIngredientsActive() {
      var rIng = verticalVisibleRatio(ingredientsSection);
      var rMet = verticalVisibleRatio(methodSection);
      var activeIngredients;
      if (rIng >= 0.5 || rMet >= 0.5) {
        activeIngredients = rMet < 0.5 || rIng >= rMet;
      } else {
        activeIngredients = rIng >= rMet;
      }
      ingredientsBtn.classList.toggle('active', activeIngredients);
      methodBtn.classList.toggle('active', !activeIngredients);
    }

    var tabIngredientsScrollTicking = false;
    function onTabIngredientsScrollOrResize() {
      if (tabIngredientsScrollTicking) {
        return;
      }
      tabIngredientsScrollTicking = true;
      requestAnimationFrame(function () {
        tabIngredientsScrollTicking = false;
        updateTabIngredientsActive();
      });
    }

    window.addEventListener('scroll', onTabIngredientsScrollOrResize, { passive: true });
    window.addEventListener('resize', onTabIngredientsScrollOrResize, { passive: true });
    onTabIngredientsScrollOrResize();

    function scrollToTarget(target) {
      if (!target) return;
      var headerHeight = getHeaderHeight();
      var top = target.getBoundingClientRect().top + window.scrollY - headerHeight - tabsWrapHeight - 40;
      window.scrollTo({ top: top, behavior: 'instant' });
      requestAnimationFrame(updateTabIngredientsActive);
    }

    ingredientsBtn.addEventListener('click', function () {
      scrollToTarget(ingredientsSection);
    });

    methodBtn.addEventListener('click', function () {
      scrollToTarget(methodSection);
    });
  });
}


// carousel community
const carouselCommunity = document.querySelectorAll('.carousel-community');
if (carouselCommunity.length > 0) {
  carouselCommunity.forEach(function (carousel) {
    var swiperEl = carousel.querySelector('.swiper-community');

    var cards = carousel.querySelectorAll('.second-row .card-community');

    // Il play-icon è visibile solo sulla slide attiva (opacity via CSS), ma
    // resterebbe comunque raggiungibile da tastiera sulle altre: lo togliamo
    // dal tab order finché la sua slide non è quella attiva.
    function syncPlayIconTabindex(activeIndex) {
      carousel.querySelectorAll('.swiper-slide').forEach(function (slide, i) {
        var playIcon = slide.querySelector('.play-icon');
        if (playIcon) playIcon.setAttribute('tabindex', i === activeIndex ? '0' : '-1');
      });
    }

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      grabCursor: true,
      loop: false,
      slideToClickedSlide: true,
      pagination: {
        el: carousel.querySelector('.carousel-pagination-community'),
        clickable: true,
      },
      breakpoints: {
        0: {
          pagination: {
            dynamicBullets: true,
            dynamicMainBullets: 3
          },
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 24,
          pagination: {
            dynamicBullets: false,
          },
        },
        1440: {
          slidesPerView: 1,
          spaceBetween: 32,
        },
      },
      on: {
        init: function () {
          sanitizeAriaHiddenControls(carousel);
        },
        paginationRender: function () {
          sanitizeAriaHiddenControls(carousel);
        },
        paginationUpdate: function () {
          sanitizeAriaHiddenControls(carousel);
        },
        slideChange: function () {
          var activeIndex = this.activeIndex;
          cards.forEach(function (card, i) {
            card.classList.toggle('active', i === activeIndex);
          });
          syncPlayIconTabindex(activeIndex);
          sanitizeAriaHiddenControls(carousel);
          var slides = carousel.querySelectorAll('.swiper-slide');
          slides.forEach(function (slide, i) {
            if (i !== activeIndex && slide.classList.contains('active-video')) {
              slide.classList.remove('active-video');
              var video = slide.querySelector('.video-wrap video');
              if (video) {
                video.pause();
                video.removeAttribute('controls');
                setTimeout(function () { video.src = ''; }, 300);
              }
            }
          });
        },
      },
    });

    syncPlayIconTabindex(swiper.activeIndex);

    carousel.querySelectorAll('.play-icon').forEach(function (playBtn) {
      playBtn.addEventListener('click', function () {
        var slide = playBtn.closest('.swiper-slide');
        if (!slide || !slide.classList.contains('swiper-slide-active')) return;
        var video = slide.querySelector('.video-wrap video');
        if (!video) return;
        var videoSrc = slide.getAttribute('data-video');
        if (videoSrc) {
          video.src = videoSrc;
          video.setAttribute('controls', '');
          slide.classList.add('active-video');
        }
      });
    });

    carousel.addEventListener('click', function (e) {
      var slide = e.target.closest('.swiper-slide');
      if (!slide || !slide.classList.contains('swiper-slide-active') || !slide.classList.contains('active-video')) return;
      if (e.target.closest('.play-icon')) return;
      var video = slide.querySelector('.video-wrap video');

      slide.classList.remove('active-video');
      if (video) {
        video.removeAttribute('controls');
        setTimeout(() => video.src = '', 300);
      }
    });

  });
}

// module media video
const moduleMediaVideo = document.querySelectorAll('.module-media-video');
if (moduleMediaVideo.length > 0) {
  moduleMediaVideo.forEach(function (section) {
    const posterOverlay = section.querySelector('.poster-overlay');
    if (!posterOverlay) return;

    const wrapper = section.querySelector('.video-wrapper');
    if (!wrapper) return;

    const video = wrapper.querySelector('video');

    posterOverlay.addEventListener('click', function () {
      playPosterMedia(posterOverlay, wrapper);
    });

    if (video) {
      video.addEventListener('pause', function () {
        posterOverlay.classList.remove('hidden');
      });
    }
  });
}


//banner-feature-simple
const bannerFeatureSimple = document.querySelectorAll('.banner-feature-simple');
if (bannerFeatureSimple.length > 0) {
  bannerFeatureSimple.forEach(function (section) {
    const itemsParent = section.querySelector('.items');
    const items = itemsParent.querySelectorAll('p');
    const lionsMask = section.querySelector('.lions-mask');
    const lions = section.querySelectorAll('.lions svg');
    if (lions.length > 0) {
      animateLions(lions, { mask: lionsMask, trigger: section });
    }
    items.forEach(function (item) {
      gsap.from(item, {
        opacity: 0,
        scrollTrigger: {
          trigger: item,
          start: 'clamp(top bottom)',
          end: 'clamp(bottom bottom-=45%)',
          scrub: true,
        },
      });
    });
  });
}

//banner-stand-up
const bannerStandUp = document.querySelectorAll('.banner-stand-up');
if (bannerStandUp.length > 0) {
  bannerStandUp.forEach(function (section) {
    const textArea = section.querySelector('.text-area');
    const imageArea = section.querySelector('.image-area');
    const container = section.querySelector('.container-mutti');

    // Sovrappone la card all'immagine usando una margin-top negativa (layout-aware):
    // offset = frazione (--standup-overlap) dell'altezza reale della card.
    // A differenza di translateY, la margin riduce davvero l'altezza del parent.
    function applyStandUpOverlap() {
      const pct = parseFloat(getComputedStyle(textArea).getPropertyValue('--standup-overlap')) || 0;
      const offset = pct * textArea.offsetHeight;
      container.style.marginTop = (-offset) + 'px';
    }

    applyStandUpOverlap();
    window.addEventListener('load', function () {
      applyStandUpOverlap();
      ScrollTrigger.refresh();
    });

    // Su iOS `resize` scatta anche quando la barra degli indirizzi compare o
    // scompare durante lo scroll: ricalcolare la margin e fare refresh in quel
    // momento sposta il layout a metà scroll. L'overlap dipende solo dalla
    // larghezza (a capo del testo), quindi reagisco solo ai cambi di larghezza.
    let standUpLastWidth = window.innerWidth;
    let standUpResizeTimer = null;
    window.addEventListener('resize', function () {
      if (window.innerWidth === standUpLastWidth) return;
      standUpLastWidth = window.innerWidth;

      clearTimeout(standUpResizeTimer);
      standUpResizeTimer = setTimeout(function () {
        applyStandUpOverlap();
        ScrollTrigger.refresh();
      }, 150);
    });

    const mm = gsap.matchMedia();

    mm.add('(min-width: 1024px)', function () {
      gsap.from(textArea, {
        yPercent: 150,
        scrollTrigger: {
          trigger: imageArea,
          start: 'top top+=60%',
          end: 'bottom bottom-=60%',
          scrub: true,
        },
      });
    });

    mm.add('(max-width: 1023px)', function () {
      gsap.from(textArea, {
        yPercent: 100,
        scrollTrigger: {
          trigger: imageArea,
          start: 'top top+=80%',
          end: 'bottom center-=20%',
          scrub: 0.01,
        },
      });
    });
  });
}

// carousel highlights
const carouselHighlights = document.querySelectorAll('.carousel-highlights');
if (carouselHighlights.length > 0) {
  carouselHighlights.forEach(function (section) {
    const swiperEl = section.querySelector(".highlights-swiper");
    const row = section.querySelector(".inner-row");
    const slides = row.querySelectorAll(".slide");
    const pagination = section.querySelector(".carousel-pagination-bullets");
    const captions = section.querySelectorAll(".slides-caption a");
    const totalIndex = section.querySelector(".total-index");
    const currentIndex = section.querySelector(".current-index");
    if (!swiperEl || slides.length === 0) return;

    let activeIndex;

    if (totalIndex) {
      totalIndex.textContent = String(slides.length).padStart(2, "0");
    }

    // Numero di slide visibili in base al breakpoint:
    // desktop = 5 (attiva 80% + 4x5%), da tablet in giù = 3 (attiva 80% + 2x10%).
    function getVisible() {
      return window.innerWidth <= 1023 ? 3 : 5;
    }

    // Indice attivo iniziale = centro della finestra visibile (o centro del
    // totale se le slide sono meno di quelle visibili).
    function getActiveStart() {
      const visible = getVisible();
      if (slides.length <= visible) {
        return Math.floor((slides.length - 1) / 2);
      }
      return (visible - 1) / 2;
    }

    activeIndex = 2;

    // Bullet: click → cambia slide tramite Swiper (come le slide non attive).
    let bullets = [];
    if (pagination) {
      slides.forEach(function (_, index) {
        const bullet = document.createElement("div");
        bullet.className = "swiper-pagination-bullet";
        bullet.addEventListener("click", function () {
          swiper.slideTo(index);
        });
        pagination.appendChild(bullet);
        bullets.push(bullet);
      });
    }

    // Posizionamento custom: l'attiva resta centrata con N slide collassate per lato.
    // collapsed = larghezza % di una slide collassata (5% desktop, 10% tablet).
    function sliderPosition() {
      const visible = getVisible();
      const side = (visible - 1) / 2;          // slide collassate per lato (2 desktop, 1 tablet)
      const collapsed = 20 / (visible - 1);    // larghezza % di una slide collassata (5 desktop, 10 tablet)
      const maxLeft = slides.length - visible; // scroll massimo: le ultime "visible" slide riempiono la vista

      let left = activeIndex - side;
      if (left < 0) left = 0;
      if (maxLeft < 0) {
        left = 0; // meno slide di quelle visibili: nessuno scroll
      } else if (left > maxLeft) {
        left = maxLeft;
      }

      row.style.left = `-${collapsed * left}%`;
    }

    // Sincronizza classi attive, caption, bullet e indice corrente con la slide attiva.
    function setActive(index) {
      if (index === activeIndex && slides[index].classList.contains("active")) {
        sliderPosition();
        return;
      }
      slides.forEach(function (slide, i) {
        slide.classList.toggle("active", i === index);
      });
      if (bullets.length > 0) {
        bullets.forEach(function (bullet, i) {
          bullet.classList.toggle("swiper-pagination-bullet-active", i === index);
        });
      }
      captions.forEach(function (caption, i) {
        caption.classList.toggle("active", i === index);
      });
      if (currentIndex) {
        currentIndex.textContent = String(index + 1).padStart(2, "0");
      }
      activeIndex = index;
      sliderPosition();
    }

    // Swiper gestisce gesture/drag e indice attivo; il layout (larghezze dinamiche +
    // collassate per lato) resta custom, quindi disabilitiamo la traslazione del wrapper
    // con virtualTranslate e posizioniamo noi via sliderPosition().
    // longSwipes:false → ogni swipe avanza di una sola slide (niente salti da 2+).
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      centeredSlides: true,
      virtualTranslate: true,
      followFinger: false,
      longSwipes: false,
      initialSlide: activeIndex,
      speed: 300,
      on: {
        slideChange: function () {
          setActive(this.activeIndex);
        },
      },
    });

    // Click su una slide non attiva → la porta all'indice cliccato (come i bullet),
    // senza seguire il link; sulla slide attiva il link resta cliccabile.
    slides.forEach(function (slide, index) {
      slide.addEventListener("click", function (e) {
        if (index !== swiper.activeIndex) {
          e.preventDefault();
          swiper.slideTo(index);
        }
      });
    });

    // Stato iniziale.
    setActive(activeIndex);

    // al cambio di breakpoint cambia il numero di slide visibili: ricalcola.
    window.addEventListener("resize", sliderPosition);
  });
}

// banner feature content
const bannerFeatureContent = document.querySelectorAll('.banner-feature-content');
if (bannerFeatureContent.length > 0) {
  bannerFeatureContent.forEach(function (section) {
    const items = section.querySelectorAll('.description-text');
    const splitElements = SplitText.create(items, {
      type: 'words',
      wordsClass: 'split-text-word',
    });


    const words = splitElements.words;
    if (!words.length) return;

    const wordDuration = 1;

    gsap.set(words, { opacity: 0.5 });
    const lions = section.querySelectorAll('.lions svg');
    if (lions.length > 0) {
      animateLions(lions, { tabletYPercent: 40 });
    }
    gsap.timeline({
      scrollTrigger: {
        trigger: section.querySelector('.description-text'),
        start: 'clamp(top bottom-=15%)',
        end: 'clamp(bottom bottom-=45%)',
        scrub: true,
      },
    }).to(words, {
      opacity: 1,
      duration: wordDuration,
      stagger: {
        each: wordDuration,
      },
      ease: 'none',
    });
  });
}


// card interactive
const cardInteractive = document.querySelectorAll('.card-interactive');
if (cardInteractive.length > 0) {
  const getCollapsedContentHeight = (header, content) => {
    const styles = window.getComputedStyle(content);
    const paddingTop = parseFloat(styles.paddingTop) || 0;
    const paddingBottom = parseFloat(styles.paddingBottom) || 0;
    return header.offsetHeight + paddingTop + paddingBottom;
  };

  const getFullCardHeight = (card) =>
    card.querySelector('.card-interactive-inner').offsetHeight;

  const collapseCard = (card) => {
    const header = card.querySelector('.card-interactive-header');
    const content = card.querySelector('.card-interactive-content');
    const description = content.querySelector('.card-interactive-description');
    const link = content.querySelector('.card-interactive-link');
    const collapsedHeight = getCollapsedContentHeight(header, content);

    gsap.killTweensOf([content, description]);
    card.classList.remove('active')
    gsap.timeline({
      defaults: { ease: 'power2.inOut' },

    })
      .to(description, { opacity: 0, duration: 0.3 }, 0)
      .to(link, { opacity: 0, duration: 0.3 }, 0)
      .to(content, {
        height: collapsedHeight,
        backgroundColor: 'transparent',
        duration: 0.4,
      }, 0.3);
  };

  const expandCard = (card) => {
    const header = card.querySelector('.card-interactive-header');
    const content = card.querySelector('.card-interactive-content');
    const description = content.querySelector('.card-interactive-description');
    const link = content.querySelector('.card-interactive-link');
    const collapsedHeight = getCollapsedContentHeight(header, content);
    const fullHeight = getFullCardHeight(card);

    gsap.killTweensOf([content, description]);
    card.classList.add('active');
    gsap.set(description, { opacity: 0 });
    gsap.set(content, { height: collapsedHeight });

    gsap.timeline({ defaults: { ease: 'power2.inOut' } })
      .to(content, {
        height: fullHeight,
        backgroundColor: '#e1f3fe',
        duration: 0.4,
      }, 0)
      .to(description, { opacity: 1, duration: 0.3 }, 0.4)
      .to(link, { opacity: 1, duration: 0.3 }, 0.4);
  };

  cardInteractive.forEach(function (section) {
    const toggleContent = section.querySelector('.toggle-content');
    const header = section.querySelector('.card-interactive-header');
    const content = section.querySelector('.card-interactive-content');
    const description = section.querySelector('.card-interactive-description');
    const link = section.querySelector('.card-interactive-link');
    gsap.set(description, { opacity: 0 });
    gsap.set(link, { opacity: 0 });
    gsap.set(content, { height: getCollapsedContentHeight(header, content) });

    toggleContent.addEventListener('click', function () {
      const willOpen = !section.classList.contains('active');
      if (willOpen) {
        expandCard(section);
      } else {
        collapseCard(section);
      }
    });
  });

  const resizeInnerHeight = () => {
    cardInteractive.forEach(function (section) {
      const header = section.querySelector('.card-interactive-header');
      const content = section.querySelector('.card-interactive-content');
      const description = section.querySelector('.card-interactive-description');
      const link = section.querySelector('.card-interactive-link');
      if (!section.classList.contains('active')) {
        gsap.set(description, { opacity: 0 });
        gsap.set(link, { opacity: 0 });
        gsap.set(content, { height: getCollapsedContentHeight(header, content) });
      } else {
        gsap.set(content, { height: getFullCardHeight(section) });
        gsap.set(description, { opacity: 1 });
        gsap.set(link, { opacity: 1 });
      }
    });
  };
  window.addEventListener('resize', resizeInnerHeight);
  resizeInnerHeight();
}

// carousel interactive
const carouselInteractive = document.querySelectorAll('.carousel-interactive');
if (carouselInteractive.length > 0) {
  carouselInteractive.forEach(function (section) {
    const swiperEl = section.querySelector('.swiper-interactive');
    const pagination = section.querySelector('.carousel-pagination-interactive');
    const slides = section.querySelectorAll('.swiper-slide');
    if (slides.length >= 8) {
      pagination.classList.add('carousel-pagination-dynamic');
    } else {
      pagination.classList.add('carousel-pagination-bullets');
    }
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      grabCursor: true,
      loop: false,
      pagination: {
        el: pagination,
        clickable: true,
        dynamicBullets: slides.length >= 8, // quando > 8 slides
        dynamicMainBullets: 1,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.45,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 2.25,
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 2.25,
          spaceBetween: 32,
        },
      },
    });
  });
}


// carousel tab


// carousel tab
const carouselTab = document.querySelectorAll('.carousel-tab');
if (carouselTab.length > 0) {
  carouselTab.forEach(function (section) {
    let imageSelectedWidth = null;
    const swiperEl = section.querySelector('.swiper-tab');
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 32,
      grabCursor: true,
      loop: false,
      breakpoints: {
        768: {
          spaceBetween: 32,
        },
        1024: {
          spaceBetween: 40,
        },
        1440: {
          spaceBetween: 48,
        },
      },
      on: {
        afterInit: function () {
          const slides = swiperEl.querySelectorAll('.swiper-slide');
          if (window.innerWidth < 1024) return;
          slides.forEach(function (slide) {
            const slideTexts = slide.querySelector('.slide-text');
            if (!slide.classList.contains('swiper-slide-active')) {
              imageSelectedWidth = slideTexts.clientWidth;
            }
          });
        },
        slideChange: function () {
          const tabsBtns = section.querySelector('.tabs-btns');
          const tabButtons = section.querySelectorAll('.tab-btn');
          const activeTabButton = section.querySelector('.tab-btn.active');
          activeTabButton.classList.remove('active');
          tabButtons[swiper.activeIndex].classList.add('active');
        },
        slidePrevTransitionStart: function () {
          if (window.innerWidth < 1024) return;
          const slides = swiperEl.querySelectorAll('.swiper-slide');
          slides.forEach(function (slide) {
            const slideImage = slide.querySelector('.slide-image');
            const slideTexts = slide.querySelector('.slide-text');
            if (slide.classList.contains('swiper-slide-active')) {
              gsap.set(slideImage, { width: imageSelectedWidth + 'px' });
              gsap.set(slideTexts, { width: imageSelectedWidth + 'px' });
            } else {
              gsap.set(slideImage, { width: 0 });
              gsap.set(slideTexts, { width: imageSelectedWidth + 'px' });
            }
          });
        },
        slideNextTransitionStart: function () {
          if (window.innerWidth < 1024) return;
          const slides = swiperEl.querySelectorAll('.swiper-slide');
          slides.forEach(function (slide) {
            const slideImage = slide.querySelector('.slide-image');
            const slideTexts = slide.querySelector('.slide-text');
            if (slide.classList.contains('swiper-slide-active')) {
              gsap.set(slideImage, { width: imageSelectedWidth + 'px' });
              gsap.set(slideTexts, { width: imageSelectedWidth + 'px' });
            } else {
              gsap.set(slideImage, { width: 0 });
              gsap.set(slideTexts, { width: imageSelectedWidth + 'px' });
            }
          });
        },
        resize: function () {

          const slides = swiperEl.querySelectorAll('.swiper-slide');

          slides.forEach(function (slide) {
            const slideImage = slide.querySelector('.slide-image');
            const slideTexts = slide.querySelector('.slide-text');
            if (window.innerWidth < 1024) {
              gsap.set(slideImage, { clearProps: 'all' });
              gsap.set(slideTexts, { clearProps: 'all' });
            } else {
              gsap.set(slideImage, { clearProps: 'all' });
              gsap.set(slideTexts, { clearProps: 'all' });
              imageSelectedWidth = slideTexts.clientWidth;
              gsap.set(slideImage, { width: slide.classList.contains('swiper-slide-active') ? imageSelectedWidth + 'px' : 0 });
              gsap.set(slideTexts, { width: imageSelectedWidth + 'px' });
            }
          });
        },

      },
    });

    // Clic su una slide → sposta il carousel verso l'indice di quella slide.
    swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide, index) {
      slide.addEventListener('click', function () {
        if (index !== swiper.activeIndex) {
          swiper.slideTo(index, 750);
        }
      });
    });

    const tabsBtns = section.querySelector('.tabs-btns');
    const tabsBtnsInner = section.querySelector('.tabs-btns-inner-slider');
    if (!tabsBtns || !tabsBtnsInner) return;

    // Abilita il drag-to-scroll sul contenitore con overflow orizzontale (solo mouse/trackpad).
    const tabsBtnsScroll = section.querySelector('.tabs-btns-inner');
    if (tabsBtnsScroll) enableDragToScroll(tabsBtnsScroll);

    const tabButtons = tabsBtnsInner.querySelectorAll('.tab-btn');
    if (!tabButtons.length) return;

    const update = createTabsOverflowUpdater(tabsBtns, tabsBtnsInner);

    tabButtons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        tabButtons.forEach(b => b.classList.remove('active'));
        button.classList.add('active');
        swiper.slideTo(index, 750);
      });
    });
    window.addEventListener('resize', update);

    document.addEventListener('DOMContentLoaded', update);

  });
}

// carousel logos
const carouselLogos = document.querySelectorAll('.carousel-logos');
if (carouselLogos.length > 0) {
  carouselLogos.forEach(function (section) {
    const swiperEl = section.querySelector('.swiper-logos');
    const prevBtnContainer = section.querySelector('.carousel-prev-btn-container');
    const nextBtnContainer = section.querySelector('.carousel-next-btn-container');
    const slideCount = section.querySelectorAll('.swiper-slide').length;

    function getSlidesPerView() {
      const w = window.innerWidth;
      if (w >= 1024) return 3;
      if (w >= 768) return 2;
      return 1;
    }

    function updateNavVisibility() {
      const hideNav = slideCount <= getSlidesPerView();
      if (prevBtnContainer) prevBtnContainer.classList.toggle('hidden', hideNav);
      if (nextBtnContainer) nextBtnContainer.classList.toggle('hidden', hideNav);
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      grabCursor: true,
      loop: false,
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: section.querySelector('.carousel-next-btn'),
        prevEl: section.querySelector('.carousel-prev-btn'),
        disabledClass: 'disabled',
      },
      pagination: {
        el: section.querySelector('.carousel-pagination-logos'),
        clickable: true,
      },
      on: {
        init: updateNavVisibility,
        resize: updateNavVisibility,
        breakpoint: updateNavVisibility,
      },
    });

    updateNavVisibility();
  });
}

// carousel media video
const carouselMediaVideo = document.querySelectorAll('.carousel-mediavideo');
if (carouselMediaVideo.length > 0) {
  carouselMediaVideo.forEach(function (section) {
    const swiperEl = section.querySelector('.swiper-mediavideo');

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      grabCursor: true,
      loop: false,
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
        1024: {
          spaceBetween: 24,
        },
        1440: {
          spaceBetween: 32,
        },
      },
      pagination: {
        el: section.querySelector('.carousel-pagination-mediavideo'),
        clickable: true,
      },
      on: {
        slideChange: function () {
          swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
            pausePosterMedia(slide);
          });
        },
      },
    });

    // Click su slide non attiva → naviga verso quella slide
    swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide, idx) {
      slide.addEventListener('click', function () {
        if (slide.classList.contains('swiper-slide-active')) return;
        swiper.slideTo(idx);
      });
    });

    // Click sul poster: se la slide è attiva → play; altrimenti lascia bubbla il click per la navigazione
    section.querySelectorAll('.poster-overlay').forEach(function (posterOverlay) {
      posterOverlay.addEventListener('click', function (e) {
        const slide = posterOverlay.closest('.swiper-slide');
        if (slide && !slide.classList.contains('swiper-slide-active')) return;

        // Solo per la slide attiva: blocca il bubbling (evita un slideTo inutile) e avvia il video
        e.stopPropagation();

        const wrapper = posterOverlay.closest('.video-wrapper');
        if (!wrapper) return;

        playPosterMedia(posterOverlay, wrapper);
      });
    });

  });
}

// side by side
const sideBySide = document.querySelectorAll('.side-by-side');
if (sideBySide.length > 0) {
  sideBySide.forEach(function (section) {
    const imageWrap = section.querySelector('.image-wrap img');
    if (imageWrap) {
      gsap.set(imageWrap, { yPercent: 0 });
      gsap.to(imageWrap, {
        yPercent: -16,
        scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true, }
      });
    }
  });
}


// module circle sticky scroll
const moduleCircleStickyScroll = document.querySelectorAll('.module-circle-sticky-scroll');
if (moduleCircleStickyScroll.length > 0) {
  moduleCircleStickyScroll.forEach(function (section) {
    const stepsLength = section.querySelectorAll('.steps-circle__media-img').length;
    const stepWrap = section.querySelector('.step-circle-wrap');

    // Posiziona i nodi sul cerchio: replica la logica PHP.
    // Raggio 48 = r dell'SVG nel viewBox 0 0 100 100 (centro 50,50).
    // left/top in % mappano 1:1 sul contenitore .steps-circle__nodes (absolute inset-0).
    (function positionNodes() {
      const nodes = section.querySelectorAll('.steps-circle__node');
      const count = nodes.length;
      const radius = 48;
      nodes.forEach(function (node, i) {
        const angleDeg = -90 + (i * (360 / count));
        const angleRad = angleDeg * (Math.PI / 180);
        node.style.left = (50 + radius * Math.cos(angleRad)).toFixed(4) + '%';
        node.style.top = (50 + radius * Math.sin(angleRad)).toFixed(4) + '%';
      });
    }());

    function initPin() {
      const arc = section.querySelector('.steps-circle__arc-progress');
      const nodes = section.querySelectorAll('.steps-circle__node');
      const mediaImgs = section.querySelectorAll('.steps-circle__media-img');
      const circumference = 2 * Math.PI * 48;
      let lastStep = -1;
      let swiper = null;

      // Aggiorna l'arco (progress 0→1).
      // animate=false → immediato, segue lo scroll; true → tween morbido (mobile/click).
      function setArc(progress, animate) {
        if (!arc) return;
        const value = circumference * (1 - progress);
        if (animate) {
          gsap.to(arc, {
            strokeDashoffset: value,
            duration: 0.4,
            ease: 'power2.out',
            overwrite: true,
          });
        } else {
          gsap.set(arc, { strokeDashoffset: value });
        }
      }

      // Aggiorna nodi e immagini in base all'indice step discreto (0-based).
      // Per mobile aggiorna anche l'arco: il nodo i è a i/stepsLength del cerchio.
      function setStep(index, updateArc) {
        if (arc && updateArc) {
          // Ultimo step: cerchio completo (1); altrimenti il nodo i è a i/stepsLength.
          setArc(index === stepsLength - 1 ? 1 : index / stepsLength, true);
        }

        if (index === lastStep) return;
        lastStep = index;

        nodes.forEach(function (node, i) {
          node.classList.toggle('is-active', i === index);
          node.classList.toggle('is-passed', i < index);
        });

        mediaImgs.forEach(function (img) {
          img.classList.toggle('is-active', parseInt(img.dataset.stepIndex, 10) === index);
        });
      }

      // Desktop: cerchio in sticky (via CSS). L'arco segue il progress dello scroll,
      // lo switch di immagini/nodi è ancorato alle posizioni reali delle slide.
      gsap.matchMedia().add('(min-width: 1024px)', function () {
        // Distrugge Swiper se attivo (es. resize da mobile a desktop).
        if (swiper) { swiper.destroy(true, true); swiper = null; }

        const contentEl = section.querySelector('.step-circle-content');
        const slides = section.querySelectorAll('.step-circle-content .swiper-slide');
        if (!slides.length) return;
        const lastSlide = slides[slides.length - 1];
        const slideTriggers = [];
        const slideTweens = [];
        let st = null;

        // Progress dell'arco ancorato alle posizioni reali delle slide:
        // - step intermedi: nodo i (i/stepsLength) raggiunto quando lo slide i è in top center,
        //   interpolando fino al top center dello slide successivo;
        // - ultimo step: dal suo top center al suo bottom center il cerchio si chiude (→ 1).
        function arcProgressFromScroll() {
          const center = window.innerHeight / 2;
          let progress = 0;
          for (let i = 0; i < slides.length; i++) {
            const rect = slides[i].getBoundingClientRect();
            const top = rect.top;
            if (top > center) break;
            const start = i / stepsLength;
            if (i === slides.length - 1) {
              const denom = rect.bottom - top;
              const seg = denom > 0 ? Math.min(Math.max((center - top) / denom, 0), 1) : 0;
              progress = start + (1 - start) * seg;
            } else {
              const nextTop = slides[i + 1].getBoundingClientRect().top;
              const denom = nextTop - top;
              const seg = denom > 0 ? Math.min(Math.max((center - top) / denom, 0), 1) : 0;
              const end = (i + 1) / stepsLength;
              progress = start + (end - start) * seg;
            }
          }
          return progress;
        }

        // Arco: segue lo scroll in modo continuo, sincronizzato con i nodi (nessun lag).
        st = ScrollTrigger.create({
          trigger: contentEl,
          start: 'top center',
          endTrigger: lastSlide,
          end: 'bottom center',
          // Più in alto nella pagina → priorità più alta: si ricalcola prima dei pin sottostanti.
          refreshPriority: 1,
          onUpdate: function () {
            setArc(arcProgressFromScroll(), false);
          },
        });

        // Immagini/nodi: switch preciso quando il top della slide tocca la metà window.
        slides.forEach(function (slide, i) {
          slideTriggers.push(ScrollTrigger.create({
            trigger: slide,
            start: 'top center',
            // Scroll giù: il top entra dal basso → attiva la slide i (arco già gestito dallo scrub).
            onEnter: function () { setStep(i, false); },
            // Scroll su: il top esce verso l'alto → torna alla slide precedente.
            onLeaveBack: function () { if (i > 0) setStep(i - 1, false); },
          }));

          // Opacità 0.4 → 1 mentre il top va dal bottom al center della window.
          slideTweens.push(gsap.fromTo(slide, { opacity: 0 }, {
            opacity: 1,
            ease: 'none',
            scrollTrigger: {
              trigger: slide,
              start: 'top bottom-=10%',
              end: 'top center',
              scrub: true,
            },
          }));
        });

        nodes.forEach(function (node) {
          node.addEventListener('click', function () {
            const idx = parseInt(node.dataset.stepIndex, 10);
            if (isNaN(idx)) return;
            const target = slides[idx];
            if (!target) return;
            const rect = target.getBoundingClientRect();
            const targetY = window.scrollY + rect.top - window.innerHeight / 2;
            window.scrollTo({ top: targetY + 5, behavior: 'smooth' });
          });
        });

        return function () {
          if (st) { st.kill(); st = null; }
          slideTriggers.forEach(function (s) { s.kill(); });
          slideTweens.forEach(function (t) {
            if (t.scrollTrigger) t.scrollTrigger.kill();
            t.kill();
          });
          gsap.set(slides, { clearProps: 'opacity' });
        };
      });

      // Mobile/tablet: Swiper, niente pin.
      gsap.matchMedia().add('(max-width: 1023px)', function () {
        const swiperEl = section.querySelector('.step-circle-swiper');
        if (swiperEl) {
          swiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            allowTouchMove: true,
            pagination: {
              el: section.querySelector('.step-circle-swiper-pagination'),
              clickable: true,
            },
            on: {
              slideChange: function () {
                setStep(swiper.activeIndex, true);
              },
            },
          });
        }

        // Click sui nodi: va alla slide corrispondente e aggiorna il cerchio.
        nodes.forEach(function (node) {
          node.addEventListener('click', function () {
            if (!swiper) return;
            const idx = parseInt(node.dataset.stepIndex, 10);
            if (isNaN(idx)) return;
            swiper.slideTo(idx);
          });
        });

        return function () {
          if (swiper) { swiper.destroy(true, true); swiper = null; }
        };
      });

      // Stato iniziale: step 0, arco completamente nascosto.
      setStep(0, true);
      ScrollTrigger.refresh();
    }

    // Attende che tutte le immagini della sezione siano caricate prima di pinnare,
    // così ScrollTrigger calcola le dimensioni corrette.
    const imgs = Array.from(section.querySelectorAll('img'));
    const promises = imgs.map(function (img) {
      if (img.complete && img.naturalWidth > 0) return Promise.resolve();
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    });

    Promise.all(promises).then(initPin);
  });
}


// highlight numbers animation
const highlightNumbersWrapper = document.querySelectorAll('.highlight-numbers-wrapper');
if (highlightNumbersWrapper.length > 0) {
  highlightNumbersWrapper.forEach(function (section) {
    section.querySelectorAll('.highlight-item-number').forEach((el, elIndex) => {
      const inner = el.querySelector('span');
      const finalValue = inner.textContent.trim();

      // Wrap iniziale per dare a SplitText qualcosa da splittare
      inner.textContent = finalValue;
      const split = new SplitText(inner, { type: 'chars' });
      const unitPool = ['%', '+', '-', '€', '$', '#', '*'];

      // Restituisce un carattere casuale dello stesso "tipo" di finalChar.
      function randomLike(finalChar) {
        if (/[0-9]/.test(finalChar)) {
          return Math.floor(Math.random() * 10).toString();
        }
        if (/[a-zA-Z]/.test(finalChar)) {
          return finalChar;
        }
        if (finalChar === '.') {
          return '.';
        }
        if (finalChar === ',') {
          return ',';
        }
        return unitPool[Math.floor(Math.random() * unitPool.length)];
      }

      // Sostituisci ogni char con uno stack
      split.chars.forEach(charEl => {
        const finalChar = charEl.textContent;

        const sequence = [];
        for (let k = 0; k < 3; k++) {
          sequence.push(randomLike(finalChar));
        }
        sequence.push(finalChar);

        charEl.classList.add('digit-wrap');
        charEl.innerHTML = `<span class="digit-stack">${sequence.map(c => `<span>${c === ' ' ? '&nbsp;' : c}</span>`).join('')
          }</span>`;
      });
      gsap.set(el.querySelectorAll('.digit-stack'), { y: '25%' });
      // Animazione al viewport entry
      ScrollTrigger.create({
        trigger: el,
        start: 'top 80%',
        once: true,
        onEnter: () => {
          gsap.to(el.querySelectorAll('.digit-stack'), {
            y: '-75%',
            duration: 1,
            ease: 'power3.inOut',
            stagger: 0.05,
            delay: elIndex * 0.01,
          });
        }
      });
    });
  });
}


// module doorways — effetto maschera come units.gr (why-list-wrap)
const moduleDoorways = document.querySelectorAll('.module-doorways');
if (moduleDoorways.length > 0) {
  const setupDoorwayItem = (item) => {
    const imageWrap = item.querySelector('.doorway-item-image');
    const img = imageWrap?.querySelector('img');
    const content = item.querySelector('.doorway-item-content');
    if (!imageWrap || !img || !content) return;

    item.style.removeProperty('height');
    item.style.removeProperty('--doorway-image-height');
    imageWrap.style.removeProperty('aspect-ratio');
    img.style.removeProperty('height');

    if (!window.matchMedia('(min-width: 1024px)').matches) return;

    const imageHeight = imageWrap.offsetHeight;
    const contentHeight = content.offsetHeight;

    item.style.height = `${imageHeight + contentHeight}px`;
    item.style.setProperty('--doorway-image-height', `${imageHeight}px`);
    imageWrap.style.aspectRatio = 'auto';
  };

  const refreshDoorways = () => {
    moduleDoorways.forEach(function (section) {
      section.querySelectorAll('.doorway-item').forEach(setupDoorwayItem);
    });
  };

  moduleDoorways.forEach(function (section) {
    section.querySelectorAll('.doorway-item img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', refreshDoorways, { once: true });
    });
  });

  window.addEventListener('resize', refreshDoorways);
  refreshDoorways();
}


// module sticky scroll
const moduleStickyScroll = document.querySelectorAll('.module-sticky-scroll');
if (moduleStickyScroll.length > 0) {
  moduleStickyScroll.forEach(function (section) {
    const contentWraps = section.querySelectorAll('.content-wrap');
    const imageCol = section.querySelector('.images-col');
    const imageWraps = imageCol.querySelectorAll('.image-wrap');

    // Stato iniziale: prima immagine visibile, le altre posizionate sotto.
    gsap.set(Array.from(imageWraps).slice(1), { yPercent: 100 });

    gsap.matchMedia().add('(min-width: 768px)', function () {
      const headerHeight = getHeaderHeight();

      // Pin dell'intera colonna immagini per la durata della sezione.
      const pinST = ScrollTrigger.create({
        trigger: imageCol,
        start: `center center`,
        endTrigger: section.querySelector('.content-col'),
        end: 'bottom bottom-=20%',
        pin: true,
        pinSpacing: false,
        // Più in basso nella pagina → priorità più bassa: si ricalcola dopo i pin sovrastanti,
        // così lo start tiene conto dello spazio che i pin sopra aggiungono al layout.
        refreshPriority: -1,
      });

      // Per ogni content-wrap (dal secondo in poi), anima l'immagine corrispondente.
      // Scroll down → immagine sale da sotto (yPercent 100 → 0).
      // Scroll up   → immagine scivola di nuovo fuori sotto (yPercent 0 → 100).
      contentWraps.forEach(function (wrap, i) {
        if (i === 0) return;
        ScrollTrigger.create({
          trigger: wrap,
          start: 'top center',
          onEnter: function () {
            gsap.to(imageWraps[i], { yPercent: 0, duration: 0.6, ease: 'power2.out' });
          },
          onLeaveBack: function () {
            gsap.to(imageWraps[i], { yPercent: 100, duration: 0.6, ease: 'power2.out' });
          },
        });
      });

      return function () {
        pinST.kill();
        gsap.set(Array.from(imageWraps).slice(1), { yPercent: 100 });
      };
    });
  });
}


// module sticky scroll accordion
const moduleStickyScrollAccordion = document.querySelectorAll('.module-sticky-scroll-accordion');
if (moduleStickyScrollAccordion.length > 0) {
  moduleStickyScrollAccordion.forEach(function (section) {
    const accordionHeaders = section.querySelectorAll('.accordion-item-header');
    accordionHeaders.forEach(function (header) {
      bindGsapHeightAccordion(
        header,
        function () { return header.parentNode.querySelector('.accordion-item-content'); },
        header.parentNode
      );
    });
    const highlightCards = section.querySelectorAll('.highlight-card');
    highlightCards.forEach(function (card) {
      const cardImage = card.querySelector('.image');
      gsap.from(card, {
        opacity: 0,
        yPercent: 10,
        duration: 0.75,
        ease: 'power2.in',
        scrollTrigger: {
          trigger: card,
          start: 'bottom bottom',
          once: true,
        },
      });
      gsap.to(cardImage, {
        opacity: 1,
        x: cardImage.parentElement.offsetWidth - cardImage.offsetWidth,
        duration: 3,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: card,
          start: 'bottom bottom',
        },
      });
    });
  });
}

// accordion inner documents (toggle)
const accordionGroups = document.querySelectorAll('.accordion-group');
if (accordionGroups.length > 0) {
  accordionGroups.forEach(function (group) {
    const accordionItems = group.querySelectorAll('.accordion-items .item');

    accordionItems.forEach(function (item) {
      const header = item.querySelector('.item-header');
      bindGsapHeightAccordion(
        header,
        function () { return item.querySelector('.item-content-wrap'); },
        header
      );
    });
  });
}

// accordion sticky documents
const accordionStickyDocuments = document.querySelectorAll('.accordion-sticky-documents');
if (accordionStickyDocuments.length > 0) {
  accordionStickyDocuments.forEach(function (section) {
    const accordionGroupWraps = section.querySelectorAll('.accordion-group-wrap');
    const accordionGroupTitles = section.querySelectorAll('.group-title');
    const groupTitleColumn = section.querySelector('.group-title-column');

    accordionGroupWraps.forEach(function (accordionGroupWrap, index) {
      ScrollTrigger.create({
        trigger: accordionGroupWrap,
        start: 'top top+=50%',
        end: 'bottom top+=50%',
        toggleClass: {
          targets: accordionGroupTitles[index],
          className: 'active',
        },
      });
    });

    function resize() {
      if (window.innerWidth >= 768) {
        console.log(groupTitleColumn);
        const groupHeight = groupTitleColumn.offsetHeight;
        console.log(groupHeight);
        groupTitleColumn.style.top = `calc(50% - ${groupHeight / 2}px)`;
      }
    }
    window.addEventListener('resize', resize);
    resize();

    accordionGroupTitles.forEach(function (accordionGroupTitle, index) {
      accordionGroupTitle.addEventListener('click', function () {
        const targetWrap = accordionGroupWraps[index];
        if (!targetWrap) return;
        const top = targetWrap.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.5;
        window.scrollTo({ top: top + 2, behavior: 'smooth' });
      });
    });
  });
}


//banner-media-content
const bannerMediaContent = document.querySelectorAll('.banner-media-content');
if (bannerMediaContent.length > 0) {
  bannerMediaContent.forEach(function (section) {
    const textRow = section.querySelector('.text-content-row');
    const textArea = section.querySelector('.text-content-bg');
    const mediaArea = section.querySelector('.media-content-wrap');
    const container = section.querySelector('.text-content-row');
    const playIcon = mediaArea.querySelector('.play-icon');
    const video = mediaArea.querySelector('.media-content-video');
    const iframe = mediaArea.querySelector('.media-content-iframe');
    const closeButton = mediaArea.querySelector('.close-button');

    function resetMedia() {
      if (video) {
        video.classList.remove('is-active');
        video.src = '';
        video.pause();
      }

      if (iframe) {
        iframe.classList.remove('is-active');
        iframe.setAttribute('src', '');
      }
    }

    if (playIcon) {
      makeKeyboardActivatable(playIcon);
      playIcon.addEventListener('click', function () {
        const videoSrc = playIcon.dataset.video;
        const iframeSrc = playIcon.dataset.iframe;

        resetMedia();

        if (videoSrc && video) {
          video.src = videoSrc;
          video.classList.add('is-active');
          video.play();
        } else if (iframeSrc && iframe) {
          iframe.setAttribute('src', toEmbedUrl(iframeSrc));
          iframe.classList.add('is-active');
        }

        mediaArea.classList.add('play');
        textRow.classList.add('play');
        if (closeButton) closeButton.focus();
      });
    }
    if (closeButton) {
      makeKeyboardActivatable(closeButton);
      closeButton.addEventListener('click', function () {
        mediaArea.classList.remove('play');
        textRow.classList.remove('play');
        resetMedia();
        playIcon.focus();
      });
    }
    // Traduce la traslazione yPercent corrente del textArea in pixel (relativi all'altezza
    // reale del textArea) e la sottrae come margin-bottom negativa alla sezione: il transform
    // sposta la card verso l'alto ma non accorcia il layout, lasciando uno spazio vuoto sotto
    // pari alla traslazione → lo riassorbiamo così (yPercent% è relativo al textArea, non al container).
    let standUpTween = null;
    function applyStandUpOverlap() {
      const target = standUpTween ? (standUpTween.vars.yPercent || 0) : 0;
      const progress = (standUpTween && standUpTween.scrollTrigger) ? standUpTween.scrollTrigger.progress : 0;
      const currentYPercent = target * progress;
      const offsetPx = (currentYPercent / 100) * textArea.offsetHeight;
      section.style.marginBottom = offsetPx + 'px';
    }

    applyStandUpOverlap();
    window.addEventListener('load', function () {
      ScrollTrigger.refresh();
      applyStandUpOverlap();
    });
    // Solo sui cambi di larghezza: su iOS `resize` scatta anche per la barra
    // degli indirizzi durante lo scroll e il refresh lì causa salti.
    let mediaContentLastWidth = window.innerWidth;
    let mediaContentResizeTimer = null;
    window.addEventListener('resize', function () {
      if (window.innerWidth === mediaContentLastWidth) return;
      mediaContentLastWidth = window.innerWidth;

      clearTimeout(mediaContentResizeTimer);
      mediaContentResizeTimer = setTimeout(function () {
        ScrollTrigger.refresh();
        applyStandUpOverlap();
      }, 150);
    });

    const mm = gsap.matchMedia();
    mm.add({
      isMobile: '(max-width: 767px)',
      isTablet: '(min-width: 768px) and (max-width: 1023px)',
      isDesktop: '(min-width: 1024px) and (max-width: 1439px)',
      isLarge: '(min-width: 1440px)',
    }, function (context) {
      const { isTablet, isDesktop, isLarge } = context.conditions;
      let yPercent = 0;
      if (isTablet) yPercent = -35;
      else if (isDesktop) yPercent = -55;
      else if (isLarge) yPercent = -75;
      gsap.set(textArea, { yPercent: yPercent * -1 });
      standUpTween = gsap.to(textArea, {
        yPercent: yPercent,
        ease: 'none',
        scrollTrigger: {
          trigger: mediaArea,
          start: isTablet ? 'top bottom-=20%' : 'top center',
          end: 'bottom bottom',
          scrub: true,
          onUpdate: applyStandUpOverlap,
        },
      });
    });
  });
}


// carousel media gallery
const carouselMediaGallery = document.querySelectorAll('.carousel-media-gallery');
if (carouselMediaGallery.length > 0) {
  carouselMediaGallery.forEach(function (section) {
    const swiperEl = section.querySelector('.swiper-media-gallery');
    const slides = section.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;

    if (slideCount <= 1) {
      section.classList.add('no-swiper');
      return;
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      grabCursor: true,
      loop: false,
      pagination: {
        el: section.querySelector('.carousel-pagination-media-gallery'),
        clickable: true,
      },
      navigation: {
        nextEl: section.querySelector('.carousel-next-btn'),
        prevEl: section.querySelector('.carousel-prev-btn'),
        disabledClass: 'disabled',
      },
    });
  });
}


// carousel tomato varieties
const carouselTomatoVarieties = document.querySelectorAll('.carousel-tomato-varieties');
if (carouselTomatoVarieties.length > 0) {
  carouselTomatoVarieties.forEach(function (section) {
    const swiperEl = section.querySelector('.swiper-tomato-varieties');
    const slides = section.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    const titlesSlider = section.querySelector('.title-slider');
    const titles = section.querySelectorAll('.title-slider p');
    const currentSteps = section.querySelector('.current-steps');

    // Pinna entrambi i bottoni: dal momento in cui il loro top raggiunge
    // l'header-height, fino a quando il centro di .image-wrap raggiunge la
    // stessa posizione.
    const imageWrap = section.querySelector('.image-wrap');
    ScrollTrigger.matchMedia({
      '(max-width: 1023px)': function () {
        section.querySelectorAll('.carousel-btns').forEach(function (btn) {
          ScrollTrigger.create({
            trigger: btn,
            endTrigger: imageWrap,
            start: function () { return 'top top+=' + getHeaderHeight(); },
            end: function () { return 'center top+=' + getHeaderHeight(); },
            pin: btn,
            pinSpacing: false,
          });
        });
      },
    });
    // Funzione centralizzata: tiene allineati titolo attivo (sempre centrato),
    // counter (current-steps) e slide di Swiper.
    if (titlesSlider) titlesSlider.setAttribute('role', 'tablist');
    titles.forEach(function (title, i) {
      title.setAttribute('role', 'tab');
      title.setAttribute('tabindex', i === 0 ? '0' : '-1');
      title.setAttribute('aria-selected', 'false');
    });

    function goTo(index) {
      // titolo attivo
      titles.forEach(function (title, i) {
        const isActive = i === index;
        title.classList.toggle('active', isActive);
        title.setAttribute('aria-selected', isActive ? 'true' : 'false');
        title.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      // centra il titolo attivo: il container è in left:50%, lo trasliamo a
      // sinistra fino a portare il centro del titolo attivo sul centro pagina.
      const activeTitle = titles[index];
      if (activeTitle && titlesSlider) {
        const offset = activeTitle.offsetLeft + activeTitle.offsetWidth / 2;
        titlesSlider.style.transform = 'translateX(-' + offset + 'px)';
      }

      // counter: scorre verticalmente il numero attivo
      if (currentSteps) {
        currentSteps.style.transform = 'translateY(-' + (100 / slideCount) * index + '%)';
      }

      // slide: il guard evita il loop (slideChange richiama goTo con lo stesso index)
      if (swiper.activeIndex !== index) {
        swiper.slideTo(index);
      }
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      speed: 500,
      autoHeight: true,
      on: {
        // swipe/cambio slide → aggiorna titolo + counter
        slideChange: function () {
          goTo(this.activeIndex);
        },
        breakpoint: function () {
          if (!this.params.autoHeight) {
            this.wrapperEl.style.height = '';
          }
        },
      },
      navigation: {
        nextEl: section.querySelector('.carousel-next-btn'),
        prevEl: section.querySelector('.carousel-prev-btn'),
        disabledClass: 'disabled',
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
          autoHeight: true,
        },
        1024: {
          autoHeight: false,
        },
      },
    });

    // click sul titolo → cambia slide (che a sua volta richiama goTo)
    titles.forEach(function (title, i) {
      title.addEventListener('click', function () {
        goTo(i);
      });
      title.addEventListener('keydown', function (e) {
        const count = titles.length;
        let target = null;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          goTo(i);
          return;
        }
        if (e.key === 'ArrowRight') target = (i + 1) % count;
        else if (e.key === 'ArrowLeft') target = (i - 1 + count) % count;
        else if (e.key === 'Home') target = 0;
        else if (e.key === 'End') target = count - 1;
        if (target === null) return;
        e.preventDefault();
        goTo(target);
        titles[target].focus();
      });
    });

    // stato iniziale + ricalcolo del centraggio quando cambiano le dimensioni/font
    goTo(swiper.activeIndex);
    window.addEventListener('load', function () {
      goTo(swiper.activeIndex);
    });
    window.addEventListener('resize', function () {
      goTo(swiper.activeIndex);
    });

  });
}


// carousel overlapping (stack di card: 3 visibili, una dietro l'altra)
const carouselOverlapping = document.querySelectorAll('.carousel-overlapping');
if (carouselOverlapping.length > 0) {
  carouselOverlapping.forEach(function (section) {
    const swiperEl = section.querySelector('.swiper-overlapping');
    if (!swiperEl) return;
    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const singleWrap = section.closest('.carousel-overlapping-single');
    const contentSlides = singleWrap
      ? singleWrap.querySelectorAll('.content-wrap .content-slide')
      : [];

    // Offset verticale della card frontale dal contenitore (48px desktop, 32px mobile).
    function topOffset() {
      return window.innerWidth <= 767 ? 32 : 48;
    }

    // L'altezza del contenitore = altezza della card frontale (scala 1) + offset.
    function setHeight() {
      const area = swiperEl.querySelector('.swiper-slide.is-active .image-area')
        || swiperEl.querySelector('.swiper-slide .image-area');
      if (area && area.offsetHeight) {
        swiperEl.style.height = (area.offsetHeight + topOffset()) + 'px';
      }
    }

    // Assegna a ogni slide la classe di posizione nello stack in base alla distanza
    // dall'indice attivo: 0 = frontale, 1 = seconda, 2 = terza, >2 = dietro (nascoste),
    // <0 = uscite (verso il basso, opacità 0).
    function updateStack(activeIndex) {
      slides.forEach(function (slide, i) {
        const offset = i - activeIndex;
        slide.classList.remove('is-active', 'is-second', 'is-third', 'is-back', 'is-exited');
        if (offset === 0) slide.classList.add('is-active');
        else if (offset === 1) slide.classList.add('is-second');
        else if (offset === 2) slide.classList.add('is-third');
        else if (offset > 2) slide.classList.add('is-back');
        else slide.classList.add('is-exited');
        slide.style.zIndex = String(offset < 0 ? 40 : 30 - offset);
      });

      // module-overlapping-single: sincronizza il contenuto testuale con la slide attiva.
      if (contentSlides.length) {
        contentSlides.forEach(function (contentSlide, i) {
          contentSlide.classList.toggle('is-active', i === activeIndex);
        });
      }

      setHeight();
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      grabCursor: true,
      loop: false,
      // Lo stack è posizionato via CSS: blocchiamo la traslazione orizzontale del wrapper.
      virtualTranslate: true,
      followFinger: false,
      longSwipes: false,
      threshold: 5,
      navigation: {
        nextEl: section.querySelector('.arrow-next-btn'),
        prevEl: section.querySelector('.arrow-prev-btn'),
        disabledClass: 'disabled',
      },
      pagination: {
        el: section.querySelector('.carousel-pagination-overlapping'),
        clickable: true,
      },
      on: {
        init: function () { updateStack(this.activeIndex); },
        slideChange: function () { updateStack(this.activeIndex); },
      },
    });

    // Ricalcola l'altezza quando le immagini sono caricate e al resize.
    swiperEl.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', setHeight, { once: true });
    });
    window.addEventListener('resize', function () { updateStack(swiper.activeIndex); });
  });
}

// module overlapping tabs
const moduleOverlappingTabs = document.querySelectorAll('.module-overlapping-tabs');
if (moduleOverlappingTabs.length > 0) {
  moduleOverlappingTabs.forEach(function (section) {
    const tabsBtns = section.querySelector('.tabs-btns');
    const tabsBtnsInner = section.querySelector('.tabs-btns-inner-slider');
    if (!tabsBtns || !tabsBtnsInner) return;

    const tabButtons = tabsBtnsInner.querySelectorAll('.tab-btn');
    if (!tabButtons.length) return;

    const carouselWraps = section.querySelectorAll('.carousel-wrap');

    const update = createTabsOverflowUpdater(tabsBtns, tabsBtnsInner);
    const setActive = createSimpleTabs(tabButtons, carouselWraps);

    // Stato iniziale: primo tab/carousel attivo.
    setActive(0);
    window.addEventListener('resize', update);

    document.addEventListener('DOMContentLoaded', update);


  })

}


//module overlapping single & tabs
const moduleOverlappingSingleTabs = document.querySelectorAll('.module-overlapping');
if (moduleOverlappingSingleTabs.length > 0) {
  moduleOverlappingSingleTabs.forEach(function (section) {
    // video modal
    const overlayModalVideo = section.querySelector('.overlay-modal-video');
    if (overlayModalVideo) {
      const closeButton = overlayModalVideo.querySelector('.close-button');
      const overlayBg = overlayModalVideo.querySelector('.overlay-bg');
      const mediaVideo = overlayModalVideo.querySelector('.media-content-video');
      const iframeMain = overlayModalVideo.querySelector('.media-content-iframe-main');
      const iframeDesktop = overlayModalVideo.querySelector('.media-content-iframe-desktop');
      const iframeMobile = overlayModalVideo.querySelector('.media-content-iframe-mobile');
      const modal = createVideoModalController(
        overlayModalVideo,
        [mediaVideo, iframeMain, iframeDesktop, iframeMobile],
        { video: mediaVideo }
      );

      section.querySelectorAll('.play-icon').forEach(function (playIcon) {
        makeKeyboardActivatable(playIcon);
        playIcon.addEventListener('click', function () {
          const video = playIcon.dataset.video;
          const iframe = playIcon.dataset.iframe;
          const iframeMobileSrc = playIcon.dataset.iframeMobile;

          modal.resetMedia();

          if (video && mediaVideo) {
            // Solo video locale.
            mediaVideo.setAttribute('src', video);
            mediaVideo.classList.add('is-active');
            mediaVideo.addEventListener('loadedmetadata', function onMeta() {
              mediaVideo.removeEventListener('loadedmetadata', onMeta);
              const isPortrait = mediaVideo.videoHeight > mediaVideo.videoWidth;
              mediaVideo.classList.toggle('is-portrait', isPortrait);
              mediaVideo.classList.toggle('is-landscape', !isPortrait);
            });
            mediaVideo.load();
            const playPromise = mediaVideo.play();
            if (playPromise) playPromise.catch(function () { });
          } else if (iframe && iframeMobileSrc && iframeDesktop && iframeMobile) {
            // Iframe con versione desktop e mobile distinte.
            iframeDesktop.setAttribute('src', toEmbedUrl(iframe));
            iframeMobile.setAttribute('src', toEmbedUrl(iframeMobileSrc));
            iframeDesktop.classList.add('is-active');
            iframeMobile.classList.add('is-active');
          } else if (iframe && iframeMain) {
            // Singolo iframe.
            iframeMain.setAttribute('src', toEmbedUrl(iframe));
            iframeMain.classList.add('is-active');
          }

          modal.openModal(playIcon);
        });
      });

      if (closeButton) closeButton.addEventListener('click', modal.closeModal);
      if (overlayBg) overlayBg.addEventListener('click', modal.closeModal);
    }

  });
}


// module contact tabs
const moduleContactTabs = document.querySelectorAll('.module-contact-tabs');
if (moduleContactTabs.length > 0) {
  moduleContactTabs.forEach(function (section) {
    const tabsBtns = section.querySelector('.tabs-btns');
    const tabsBtnsInner = section.querySelector('.tabs-btns-inner-slider');
    if (!tabsBtns || !tabsBtnsInner) return;

    const tabButtons = tabsBtnsInner.querySelectorAll('.tab-btn');
    if (!tabButtons.length) return;

    const gridContactWraps = section.querySelectorAll('.grid-contact-wrap');

    const update = createTabsOverflowUpdater(tabsBtns, tabsBtnsInner);
    const setActive = createSimpleTabs(tabButtons, gridContactWraps);

    // Stato iniziale: primo tab/grid attivo.
    setActive(0);
    window.addEventListener('resize', update);

    document.addEventListener('DOMContentLoaded', update);

  });
}

// card contact
const cardContact = document.querySelectorAll('.card-contact');
if (cardContact.length > 0) {
  cardContact.forEach(function (card) {
    const inner = card.querySelector('.card-contact-inner');
    const header = card.querySelector('.card-contact-header');
    const content = card.querySelector('.card-contact-content');
    if (!inner || !header || !content) return;

    const gridWrap = card.closest('.grid-contact-wrap');
    const siblingCards = gridWrap
      ? gridWrap.querySelectorAll('.card-contact')
      : [card];

    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

    const closeCard = (targetCard) => {
      const targetInner = targetCard.querySelector('.card-contact-inner');
      const targetContent = targetCard.querySelector('.card-contact-content');
      if (!targetInner || !targetContent || !targetInner.classList.contains('open')) return;

      targetContent.style.maxHeight = targetContent.scrollHeight + 'px';
      targetContent.offsetHeight;
      targetContent.style.maxHeight = '0';
      targetInner.classList.remove('open');
    };

    header.addEventListener('click', function () {
      if (!isMobile()) return;

      const isOpen = inner.classList.contains('open');

      if (isOpen) {
        closeCard(card);
      } else {
        siblingCards.forEach(function (otherCard) {
          if (otherCard !== card) closeCard(otherCard);
        });
        inner.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });


  });

}


// hero art yourself
const heroArtYourself = document.querySelectorAll('.hero-art-yourself');
if (heroArtYourself.length > 0) {
  heroArtYourself.forEach(function (section) {
    const mediaWrap = section.querySelector('.media-wrap');
    const playIcon = section.querySelector('.play-icon');
    const closeButton = mediaWrap ? mediaWrap.querySelector('.close-button') : null;
    const iframes = mediaWrap ? mediaWrap.querySelectorAll('.video-wrap iframe') : [];
    const videos = mediaWrap ? mediaWrap.querySelectorAll('.video-wrap video') : [];

    function loadIframes() {
      iframes.forEach(function (iframe) {
        const iframeSrc = iframe.dataset.src;

        if (iframeSrc && !iframe.getAttribute('src')) {
          iframe.setAttribute('src', iframeSrc);
        }
      });
    }

    // Si avvia solo il video visibile al breakpoint corrente. preload="none" è un hint:
    // riduce il download anticipato ma non garantisce che il video nascosto non venga richiesto.
    function playVideos() {
      videos.forEach(function (video) {
        if (video.offsetParent !== null) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(function () { });
        }
      });
    }

    function resetMedia() {
      iframes.forEach(function (iframe) {
        iframe.setAttribute('src', '');
      });
      videos.forEach(function (video) {
        video.pause();
        video.currentTime = 0;
      });
    }

    if (playIcon && mediaWrap) {
      makeKeyboardActivatable(playIcon);
      playIcon.addEventListener('click', function () {
        loadIframes();
        playVideos();
        mediaWrap.classList.add('play');
        if (closeButton) closeButton.focus();
      });
    }

    if (closeButton && mediaWrap) {
      closeButton.addEventListener('click', function () {
        mediaWrap.classList.remove('play');
        playIcon.focus();
        resetMedia();
      });
    }
  });
}

// hero impact full video cta modal
const heroImpactFullSections = document.querySelectorAll('.hero-impact-full');
if (heroImpactFullSections.length > 0) {
  heroImpactFullSections.forEach(function (section) {
    const videoCta = section.querySelector('.video-cta-hero');
    const overlayModalVideo = section.querySelector('.overlay-modal-video');
    if (!videoCta || !overlayModalVideo) return;

    const closeButton = overlayModalVideo.querySelector('.close-button');
    const overlayBg = overlayModalVideo.querySelector('.overlay-bg');
    const mediaVideo = overlayModalVideo.querySelector('.media-content-video');
    const iframeMain = overlayModalVideo.querySelector('.media-content-iframe-main');
    const body = document.querySelector('body');

    const modal = createVideoModalController(overlayModalVideo, [mediaVideo, iframeMain], {
      video: mediaVideo,
      onOpen: function () {
        body.style.overflow = 'hidden';
        body.style.height = '100vh';
      },
      onClose: function () {
        body.style.overflow = 'auto';
        body.style.height = 'auto';
      },
    });

    makeKeyboardActivatable(videoCta);
    videoCta.addEventListener('click', function () {
      const video = videoCta.dataset.video;
      const iframe = videoCta.dataset.iframe;

      modal.resetMedia();

      if (video && mediaVideo) {
        mediaVideo.setAttribute('src', video);
        mediaVideo.classList.add('is-active');
        mediaVideo.addEventListener('loadedmetadata', function onMeta() {
          mediaVideo.removeEventListener('loadedmetadata', onMeta);
          const isPortrait = mediaVideo.videoHeight > mediaVideo.videoWidth;
          mediaVideo.classList.toggle('is-portrait', isPortrait);
          mediaVideo.classList.toggle('is-landscape', !isPortrait);
        });
        mediaVideo.load();
        const playPromise = mediaVideo.play();
        if (playPromise) playPromise.catch(function () { });
      } else if (iframe && iframeMain) {
        iframeMain.setAttribute('src', toEmbedUrl(iframe));
        iframeMain.classList.add('is-active');
      }

      modal.openModal(videoCta);
    });

    if (closeButton) closeButton.addEventListener('click', modal.closeModal);
    if (overlayBg) overlayBg.addEventListener('click', modal.closeModal);
  });
}

// hero homepage
const heroHomepage = document.querySelectorAll('.hero-homepage');
if (heroHomepage.length > 0) {
  heroHomepage.forEach(function (section) {
    const backgroundContainer = section.querySelector('.background-container');
    const backgroundVideo = section.querySelector('.background-video');

    // if (backgroundContainer) {
    //   var currentY = 0;
    //   var targetY = 0;
    //   var rafId = null;
    //   var lerpFactor = 1;

    //   function lerp(a, b, t) {
    //     return a + (b - a) * t;
    //   }

    //   function tick() {
    //     currentY = lerp(currentY, targetY, lerpFactor);
    //     backgroundContainer.style.transform = 'translate3d(0,' + currentY.toFixed(3) + 'px,0)';
    //     if (Math.abs(targetY - currentY) > 0.05) {
    //       rafId = requestAnimationFrame(tick);
    //     } else {
    //       rafId = null;
    //     }
    //   }

    //   function onHeroVideoScroll() {
    //     var rect = section.getBoundingClientRect();
    //     var vh = window.innerHeight;

    //     if (rect.bottom <= 0 || rect.top >= vh) {
    //       if (backgroundVideo && !backgroundVideo.paused) backgroundVideo.pause();
    //     } else if (backgroundVideo && backgroundVideo.paused) {
    //       var playPromise = backgroundVideo.play();
    //       if (playPromise) playPromise.catch(function () { });
    //     }

    //     targetY = Math.max(0, -rect.top);
    //     if (!rafId) rafId = requestAnimationFrame(tick);
    //   }

    //   window.addEventListener('scroll', onHeroVideoScroll, { passive: true });
    //   window.addEventListener('resize', onHeroVideoScroll, { passive: true });
    //   ScrollTrigger.addEventListener('refresh', onHeroVideoScroll);
    //   onHeroVideoScroll();
    // }

    if (backgroundVideo) {
      const playBackgroundVideo = () => {
        const playPromise = backgroundVideo.play();
        if (playPromise) playPromise.catch(function () { });
      };

      // Con preload="none" il video non si carica da solo: va avviato esplicitamente.
      if (backgroundVideo.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
        playBackgroundVideo();
      } else {
        backgroundVideo.addEventListener('canplay', playBackgroundVideo, { once: true });
        backgroundVideo.load();
      }
    }
    const splitElements = SplitText.create(section.querySelector('.split-home-text'), {
      type: 'words',
      linesClass: 'split-home-text-line',
    });
    const imageArea = section.querySelector('.image-container');
    if (imageArea) {
      gsap.set(imageArea, {
        opacity: 0,
        y: window.innerWidth < 1024 ? 20 : 40,
      });
    }
    gsap.set(splitElements.words, {
      opacity: 0,
      y: window.innerWidth < 1024 ? 20 : 40,
    });
    const tl = gsap.timeline({
      delay: 0.5,
    });

    tl
      .set(section.querySelector('.title'), {
        opacity: 1,
      })
      .to(splitElements.words, {
        opacity: 1,
        y: 0,
        duration: 0.65,
        stagger: 0.275,
        ease: 'power2.out',
      });
    if (imageArea) {
      tl.to(imageArea, {
        opacity: 1,
        y: 0,
        duration: 0.65,
        ease: 'power2.out',
      });
    }
  });


}

// module recipe spotlight
const moduleRecipeSpotlight = document.querySelectorAll('.module-recipe-spotlight');
if (moduleRecipeSpotlight.length > 0) {
  moduleRecipeSpotlight.forEach(function (section) {
    const accordionItems = section.querySelectorAll('.accordion-item');
    if (accordionItems.length > 0) {
      accordionItems.forEach(function (accordionItem) {
        const header = accordionItem.querySelector('.accordion-item-header');
        if (!header) return;
        header.addEventListener('click', function () {
          const isCurrentlyOpen = accordionItem.classList.contains('open');

          accordionItems.forEach(function (item) {
            item.classList.remove('open');
          });

          if (!isCurrentlyOpen) {
            accordionItem.classList.add('open');
          }
        });
      });
    }
    const titleSlider = section.querySelector('.title-slider');
    const currentSteps = section.querySelector('.current-steps');
    const currentStepsLength = currentSteps.querySelectorAll('span').length;

    const counterTotal = section.querySelector('.counter-total');
    if (counterTotal) {
      counterTotal.innerHTML = '&nbsp;/&nbsp;<span>' + currentStepsLength + '</span>';
    }

    // Le immagini vivono in .spotlight-media, fuori dal track di Swiper, così da
    // poter usare uno sticky CSS nativo. Qui le sincronizziamo con lo slide attivo.
    const spotlightImages = section.querySelectorAll('.spotlight-media .image-wrap');
    function setActiveImage(index) {
      spotlightImages.forEach(function (image, i) {
        image.classList.toggle('is-active', i === index);
      });
    }

    const swiper = new Swiper(section.querySelector('.swiper-recipe-spotlight'), {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      speed: 500,
      navigation: {
        nextEl: section.querySelector('.btn-carousel-next'),
        prevEl: section.querySelector('.btn-carousel-prev'),
        disabledClass: 'disabled',
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
      },
      on: {
        slideChangeTransitionStart: function () {
          const prevSlide = this.slides[this.previousIndex];
          if (!prevSlide) return;
          prevSlide.querySelectorAll('.accordion-item.open').forEach(function (accordionItem) {
            accordionItem.classList.remove('open');
          });
        },
        slideChange: function () {
          if (titleSlider) {
            titleSlider.style.transform = 'translateX(-' + (100) * this.activeIndex + '%)';
          }
          if (currentSteps) {
            currentSteps.style.transform = 'translateY(-' + (100 / currentStepsLength) * this.activeIndex + '%)';
          }
          setActiveImage(this.activeIndex);
        },
      },
    });

    setActiveImage(swiper.activeIndex);
  });

}


// carousel product service — title loop custom
function createProductServiceTitleLoop(wrapEl, options) {
  const flex = wrapEl.querySelector('.titles-flex-container');
  // Se il wrapper è aria-hidden i tab duplicano la navigazione: niente ruolo ARIA né tab order,
  // restano solo cliccabili col mouse.
  const exposeTabs = wrapEl.getAttribute('aria-hidden') !== 'true';
  const speed = options.speed || 500;
  const easing = options.easing || 'ease';
  const loopEnabled = options.loopEnabled !== false;
  let gap = typeof options.gap === 'number' ? options.gap : 32;
  let realItems = [];
  let count = 0;
  let currentIdx = 0;
  let currentDomIdx = 0;
  let copies = 0;
  let domOffsetStart = 0;
  let allItems = [];
  let resizeTimer = null;

  function getGap() {
    return window.innerWidth >= 1024 ? 32 : 24;
  }

  function getLoopStep(fromIndex, toIndex, total) {
    if (fromIndex === toIndex) {
      return 'none';
    }

    const forward = (toIndex - fromIndex + total) % total;
    const backward = (fromIndex - toIndex + total) % total;

    if (forward === 1) {
      return 'next';
    }

    if (backward === 1) {
      return 'prev';
    }

    return 'jump';
  }

  function calcCopiesNeeded() {
    const containerWidth = wrapEl.offsetWidth;
    const totalWidth = realItems.reduce(function (acc, el) {
      return acc + el.offsetWidth + gap;
    }, 0);

    if (!containerWidth || !totalWidth) {
      return 2;
    }

    return Math.max(2, Math.ceil((containerWidth * 3) / totalWidth));
  }

  function buildClones() {
    if (exposeTabs) {
      flex.setAttribute('role', 'tablist');
    }
    flex.querySelectorAll('.clone').forEach(function (clone) {
      clone.remove();
    });

    realItems = Array.from(flex.querySelectorAll('.title-item:not(.clone)'));
    count = realItems.length;
    realItems.forEach(function (el, i) {
      if (exposeTabs) {
        el.setAttribute('role', 'tab');
        el.setAttribute('tabindex', i === currentIdx ? '0' : '-1');
      } else {
        el.removeAttribute('role');
        el.setAttribute('tabindex', '-1');
      }
    });

    if (!loopEnabled || count < 3) {
      copies = 0;
      domOffsetStart = 0;
      allItems = realItems.slice();
      currentDomIdx = currentIdx;
      return;
    }

    copies = calcCopiesNeeded();

    for (let c = copies - 1; c >= 0; c--) {
      realItems.slice().reverse().forEach(function (item) {
        const clone = item.cloneNode(true);
        clone.classList.add('clone');
        clone.dataset.index = item.dataset.index;
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        flex.prepend(clone);
      });
    }

    for (let c = 0; c < copies; c++) {
      realItems.forEach(function (item) {
        const clone = item.cloneNode(true);
        clone.classList.add('clone');
        clone.dataset.index = item.dataset.index;
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        flex.append(clone);
      });
    }

    allItems = Array.from(flex.querySelectorAll('.title-item'));
    domOffsetStart = copies * count;
    currentDomIdx = domOffsetStart + currentIdx;
  }

  function calcTranslateByDomIdx(domIdx) {
    const containerWidth = wrapEl.offsetWidth;
    const targetEl = allItems[domIdx];

    if (!targetEl) {
      return 0;
    }

    const itemLeft = targetEl.offsetLeft;
    const itemWidth = targetEl.offsetWidth;

    return -(itemLeft - containerWidth / 2 + itemWidth / 2);
  }

  function findNearestDomIdx(targetRealIdx) {
    const canonicalDomIdx = domOffsetStart + targetRealIdx;
    let nearestDomIdx = canonicalDomIdx;
    let minDistance = Math.abs(canonicalDomIdx - currentDomIdx);

    allItems.forEach(function (el, i) {
      if (parseInt(el.dataset.index, 10) !== targetRealIdx) {
        return;
      }

      const distance = Math.abs(i - currentDomIdx);

      if (distance < minDistance) {
        minDistance = distance;
        nearestDomIdx = i;
      }
    });

    return nearestDomIdx;
  }

  function silentResetIfNeeded() {
    if (!loopEnabled || !count) {
      return;
    }

    const canonicalDomIdx = domOffsetStart + currentIdx;

    if (currentDomIdx === canonicalDomIdx) {
      return;
    }

    const inRealBand = currentDomIdx >= domOffsetStart && currentDomIdx < domOffsetStart + count;

    if (inRealBand) {
      return;
    }

    currentDomIdx = canonicalDomIdx;
    flex.style.transition = 'none';
    flex.style.transform = 'translateX(' + calcTranslateByDomIdx(canonicalDomIdx) + 'px)';
  }

  function applyTranslate(domIdx, animate) {
    if (animate) {
      flex.style.transition = 'transform ' + speed + 'ms ' + easing;

      const onEnd = function (e) {
        if (e.target !== flex || e.propertyName !== 'transform') {
          return;
        }

        flex.removeEventListener('transitionend', onEnd);
        silentResetIfNeeded();
      };

      flex.addEventListener('transitionend', onEnd);
    } else {
      flex.style.transition = 'none';
      silentResetIfNeeded();
    }

    flex.style.transform = 'translateX(' + calcTranslateByDomIdx(domIdx) + 'px)';
  }

  function updateActiveClass(realIdx) {
    allItems.forEach(function (el) {
      const isActive = parseInt(el.dataset.index, 10) === realIdx;
      el.classList.toggle('active', isActive);
      if (exposeTabs) {
        el.setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    });
    realItems.forEach(function (el, i) {
      el.setAttribute('tabindex', exposeTabs && i === realIdx ? '0' : '-1');
    });
  }

  function goTo(realIdx, animate, direction) {
    if (!count) {
      return;
    }

    const normalizedIdx = ((realIdx % count) + count) % count;
    const step = direction || getLoopStep(currentIdx, normalizedIdx, count);
    let targetDomIdx = currentDomIdx;

    if (!loopEnabled) {
      targetDomIdx = normalizedIdx;
    } else if (step === 'next') {
      targetDomIdx = currentDomIdx + 1;
    } else if (step === 'prev') {
      targetDomIdx = currentDomIdx - 1;
    } else {
      targetDomIdx = findNearestDomIdx(normalizedIdx);
    }

    if (targetDomIdx === currentDomIdx && normalizedIdx === currentIdx) {
      return;
    }

    currentIdx = normalizedIdx;
    currentDomIdx = targetDomIdx;
    updateActiveClass(currentIdx);
    applyTranslate(targetDomIdx, animate !== false && step !== 'none');
  }

  function bindClicks() {
    flex.addEventListener('click', function (e) {
      const item = e.target.closest('.title-item');

      if (!item || item.dataset.index === undefined || !options.onSelect) {
        return;
      }

      const index = parseInt(item.dataset.index, 10);

      if (Number.isNaN(index)) {
        return;
      }

      options.onSelect(index);
    });

    flex.addEventListener('keydown', function (e) {
      if (!exposeTabs) return;
      const item = e.target.closest('.title-item:not(.clone)');
      if (!item) return;
      const index = realItems.indexOf(item);
      if (index === -1) return;

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (options.onSelect) options.onSelect(index);
        return;
      }

      let target = null;
      if (e.key === 'ArrowRight') target = (index + 1) % count;
      else if (e.key === 'ArrowLeft') target = (index - 1 + count) % count;
      else if (e.key === 'Home') target = 0;
      else if (e.key === 'End') target = count - 1;
      if (target === null) return;
      e.preventDefault();
      realItems[target].focus();
    });
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      gap = getGap();
      flex.style.gap = gap + 'px';
      buildClones();
      updateActiveClass(currentIdx);
      applyTranslate(currentDomIdx, false);
    }, 150);
  }

  gap = getGap();
  flex.style.gap = gap + 'px';
  buildClones();
  updateActiveClass(0);
  applyTranslate(currentDomIdx, false);
  bindClicks();
  window.addEventListener('resize', onResize);

  return {
    goTo: goTo,
    getRealIndex: function () {
      return currentIdx;
    },
    destroy: function () {
      window.removeEventListener('resize', onResize);
      clearTimeout(resizeTimer);
    },
  };
}

// carousel product service
const carouselProductService = document.querySelectorAll('.carousel-product-service');
if (carouselProductService.length > 0) {
  // Le slide laterali fanno da freccia: click su quella di destra per andare
  // avanti, su quella di sinistra per tornare indietro. Uso l'evento `click` di
  // Swiper e non un listener nativo perché Swiper lo emette solo sui tap veri
  // (dopo un drag `allowClick` è false), così trascinare non fa scattare anche
  // un cambio slide in più.
  function handleSideSlideClick(swiper) {
    const slide = swiper.clickedSlide;
    if (!slide) return;

    if (slide.classList.contains('swiper-slide-next')) {
      swiper.slideNext(500);
    } else if (slide.classList.contains('swiper-slide-prev')) {
      swiper.slidePrev(500);
    }
  }

  carouselProductService.forEach(function (section) {
    const titleWrap = section.querySelector('.title-slider-wrap');
    const mainSwiperEl = section.querySelector('.swiper-product-service');
    if (!mainSwiperEl) {
      return;
    }

    const slideCount = parseInt(section.dataset.slideCount, 10) || mainSwiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    const enableLoop = slideCount >= 3;

    const mainSwiperOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: enableLoop,
      speed: 500,
      centeredSlides: true,
      touchReleaseOnEdges: true,
      resistanceRatio: 0.85,
      longSwipesRatio: 0.3,
      pagination: {
        el: section.querySelector('.carousel-pagination-bullets'),
        clickable: true,
      },
      navigation: {
        nextEl: section.querySelector('.carousel-next-btn'),
        prevEl: section.querySelector('.carousel-prev-btn'),
        disabledClass: 'disabled',
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
        1024: {
          spaceBetween: 24,
        },
        1440: {
          spaceBetween: 32,
        },
      },
    };

    if (!titleWrap) {
      const plainSwiper = new Swiper(mainSwiperEl, Object.assign({}, mainSwiperOptions, {
        on: {
          init: function () { sanitizeAriaHiddenControls(section); },
          paginationRender: function () { sanitizeAriaHiddenControls(section); },
          paginationUpdate: function () { sanitizeAriaHiddenControls(section); },
          slideChange: function () { sanitizeAriaHiddenControls(section); },
          click: handleSideSlideClick,
        },
      }));
      // Anche le istanze senza tab hanno il loop e quindi lo stesso focus trap.
      if (enableLoop) {
        createFocusLoopGuard(plainSwiper, mainSwiperEl);
      }
      return;
    }

    let titleLoop = null;
    let mainSwiper = null;
    let prevMainRealIndex = 0;
    let pendingMainSteps = 0;
    let pendingMainDirection = 'next';
    let isTitleNavigation = false;
    let slideMainToRealIndex = function () { };

    function fixMainSwiperLoopPosition() {
      // Il loop va letto a runtime: con il guard attivo può essere congelato, e in
      // quel caso loopFix()/slideToLoop() opererebbero su uno Swiper senza loop.
      if (!mainSwiper || !mainSwiper.params.loop) {
        return;
      }

      const realIndex = mainSwiper.realIndex;

      if (typeof mainSwiper.loopFix === 'function') {
        mainSwiper.loopFix();
      }

      mainSwiper.slideToLoop(realIndex, 0, false);
    }

    titleLoop = createProductServiceTitleLoop(titleWrap, {
      speed: 500,
      loopEnabled: enableLoop,
      onSelect: function (index) {
        slideMainToRealIndex(index);
      },
    });

    function slideMainStep() {
      if (pendingMainDirection === 'next') {
        mainSwiper.slideNext(500);
      } else {
        mainSwiper.slidePrev(500);
      }
    }

    mainSwiper = new Swiper(mainSwiperEl, Object.assign({}, mainSwiperOptions, {
      on: {
        init: function () {
          prevMainRealIndex = this.realIndex;
          titleLoop.goTo(this.realIndex, false);
          sanitizeAriaHiddenControls(section);
        },
        paginationRender: function () {
          sanitizeAriaHiddenControls(section);
        },
        paginationUpdate: function () {
          sanitizeAriaHiddenControls(section);
        },
        slideChange: function () {
          sanitizeAriaHiddenControls(section);
        },
        click: handleSideSlideClick,
        slideChangeTransitionStart: function () {
          const forward = (this.realIndex - prevMainRealIndex + slideCount) % slideCount;
          const backward = (prevMainRealIndex - this.realIndex + slideCount) % slideCount;
          let direction = 'jump';

          if (forward === 1) {
            direction = 'next';
          } else if (backward === 1) {
            direction = 'prev';
          }

          titleLoop.goTo(this.realIndex, true, direction);
        },
        slideChangeTransitionEnd: function () {
          prevMainRealIndex = this.realIndex;

          if (pendingMainSteps > 0) {
            slideMainStep();
            pendingMainSteps -= 1;
            return;
          }

          if (isTitleNavigation) {
            isTitleNavigation = false;

            if (enableLoop) {
              requestAnimationFrame(function () {
                fixMainSwiperLoopPosition();
              });
            }
          }
        },
      },
    }));

    if (enableLoop) {
      createFocusLoopGuard(mainSwiper, mainSwiperEl);
    }

    slideMainToRealIndex = function (targetIndex) {
      const current = mainSwiper.realIndex;

      if (current === targetIndex) {
        return;
      }

      pendingMainSteps = 0;
      isTitleNavigation = true;

      // Anche qui il loop si legge a runtime: se è congelato dal guard si naviga
      // con un semplice slideTo, senza la logica di avvicinamento circolare.
      if (!mainSwiper.params.loop) {
        mainSwiper.slideTo(targetIndex, 500);
        return;
      }

      const forward = (targetIndex - current + slideCount) % slideCount;
      const backward = (current - targetIndex + slideCount) % slideCount;

      if (forward === 1) {
        mainSwiper.slideNext(500);
        return;
      }

      if (backward === 1) {
        mainSwiper.slidePrev(500);
        return;
      }

      const steps = forward <= backward ? forward : backward;
      pendingMainDirection = forward <= backward ? 'next' : 'prev';
      pendingMainSteps = steps - 1;
      slideMainStep();
    };
  });
}

// card video wall
const videoWraps = document.querySelectorAll('.card-video-wall .video-wrap');
if (videoWraps.length > 0) {
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (supportsHover) {
    videoWraps.forEach(function (videoWrap) {
      const card = videoWrap.closest('.card-video-wall');
      const video = videoWrap.querySelector('video');
      const source = video ? video.querySelector('source') : null;
      const videoAsset = card ? card.dataset.videoAsset : '';

      if (!card || !video || !source || !videoAsset) {
        return;
      }

      let pendingCanPlay = null;

      videoWrap.addEventListener('mouseenter', function () {
        if (!source.getAttribute('src')) {
          source.src = videoAsset;
          source.type = 'video/mp4';
          video.load();
        }

        if (video.readyState >= 3) {
          video.play().catch(function () { });
          card.classList.add('is-playing');
          return;
        }

        pendingCanPlay = function () {
          video.play().catch(function () { });
          card.classList.add('is-playing');
          pendingCanPlay = null;
        };
        video.addEventListener('canplay', pendingCanPlay, { once: true });
      });

      videoWrap.addEventListener('mouseleave', function () {
        if (pendingCanPlay) {
          video.removeEventListener('canplay', pendingCanPlay);
          pendingCanPlay = null;
        }

        video.pause();
        video.currentTime = 0;
        card.classList.remove('is-playing');
      });
    });
  }
}

// module video wall
const moduleVideoWall = document.querySelectorAll('.module-video-wall');
if (moduleVideoWall.length > 0) {
  moduleVideoWall.forEach(function (section) {
    const overlayModalVideo = section.querySelector('.overlay-modal-video');
    if (!overlayModalVideo) {
      return;
    }

    const closeButton = overlayModalVideo.querySelector('.close-button');
    const overlayBg = overlayModalVideo.querySelector('.overlay-bg');
    const iframeDesktop = overlayModalVideo.querySelector('.media-content-iframe-desktop');
    const iframeMobile = overlayModalVideo.querySelector('.media-content-iframe-mobile');
    const modal = createVideoModalController(overlayModalVideo, [iframeDesktop, iframeMobile]);

    section.querySelectorAll('.card-video-wall').forEach(function (playIcon) {
      makeKeyboardActivatable(playIcon);
      playIcon.addEventListener('click', function () {
        const card = playIcon.closest('.card-video-wall');
        if (!card) {
          return;
        }

        const desktopId = card.dataset.videoId;
        const mobileId = card.dataset.videoIdMobile || desktopId;

        modal.resetMedia();

        if (desktopId && iframeDesktop) {
          iframeDesktop.setAttribute('src', toEmbedUrl(desktopId));
          iframeDesktop.classList.add('is-active');
        }

        if (mobileId && iframeMobile) {
          iframeMobile.setAttribute('src', toEmbedUrl(mobileId));
          iframeMobile.classList.add('is-active');
        }

        modal.openModal(playIcon);
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', modal.closeModal);
    }

    if (overlayBg) {
      overlayBg.addEventListener('click', modal.closeModal);
    }
  });
}

// carousel recipe home
const carouselRecipeHome = document.querySelectorAll('.carousel-recipe-home');
if (carouselRecipeHome.length > 0) {
  carouselRecipeHome.forEach(function (section) {
    const swiperRecipeHome = section.querySelector('.swiper-recipe-home');
    if (!swiperRecipeHome) {
      return;
    }
    const swiper = new Swiper(swiperRecipeHome, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      grabCursor: true,
      slideToClickedSlide: true,
      speed: 500,
      pagination: {
        el: section.querySelector('.carousel-pagination-recipe-home'),
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
        1024: {
          spaceBetween: 24,
        },
        1440: {
          spaceBetween: 32,
        },
      },
    });

    createFocusLoopGuard(swiper, swiperRecipeHome);
  });
}


// module grid tabs
const moduleGridTabs = document.querySelectorAll('.module-grid-tabs');
if (moduleGridTabs.length > 0) {
  moduleGridTabs.forEach(function (section) {
    const panes = section.querySelectorAll('.pane');
    const tabsBtns = section.querySelector('.tabs-btns');
    const tabsInner = section.querySelector('.tabs-btns-inner');
    const tabsBtnsInner = section.querySelector('.tabs-btns-inner-slider');
    if (!tabsBtns || !tabsBtnsInner) return;

    const tabButtons = tabsBtnsInner.querySelectorAll('.tab-btn');
    if (!tabButtons.length) return;

    if (tabsInner) enableDragToScroll(tabsInner);
    const update = createTabsOverflowUpdater(tabsBtns, tabsBtnsInner);
    createSimpleTabs(tabButtons, panes);

    update();
    window.addEventListener('resize', update);
  });
}

// module home scroll
const moduleHomeScroll = document.querySelectorAll('.module-home-scroll');
if (moduleHomeScroll.length > 0) {
  moduleHomeScroll.forEach(function (section) {
    let contentTimeline = null;
    let resizeTimer = null;
    let lastWidth = window.innerWidth;

    function getOffset(el) {
      return -(el.offsetWidth - window.innerWidth) / 2;
    }

    // Variabili usate dallo sticky CSS del canvas:
    // --pin-h  = altezza dell'elemento sticky
    // --pin-mb = (altezza lattina - altezza canvas) / 2, cioè il margin-bottom
    //            che fa coincidere il punto di stop con il centro della lattina
    // --pin-top = offset di aggancio, calcolato con lo stesso riferimento che usa
    //            ScrollTrigger per "center" (window.innerHeight), così sticky e
    //            tween dei frame partono nello stesso punto.
    function setStickyVars() {
      const wrap = section.querySelector('.sprite-scroll');
      const canvasEl = section.querySelector('.sprite-scroll__canvas');
      const boxEl = section.querySelector('.box-wrapper');
      if (!wrap || !canvasEl || !boxEl) return;

      const pinH = canvasEl.offsetHeight;
      const pinMb = Math.max(0, (boxEl.offsetHeight - pinH) / 2);

      // Le imposto su .sprite-scroll: ereditano sia il canvas sia .box-wrapper.
      wrap.style.setProperty('--pin-h', pinH + 'px');
      wrap.style.setProperty('--pin-mb', pinMb + 'px');
      wrap.style.setProperty('--pin-top', (window.innerHeight - pinH) / 2 + 'px');
    }

    function initContentScroll() {
      const content = section.querySelectorAll('.scroll-content');
      const scrollWrap = section.querySelector('.scoll-content-wrap');
      if (content.length < 2 || !scrollWrap) return;

      if (contentTimeline) {
        contentTimeline.scrollTrigger.kill();
        contentTimeline.kill();
        contentTimeline = null;
      }

      gsap.set(content[0], { x: 0 });
      gsap.set(content[1], { x: getOffset(content[1]) });

      contentTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: scrollWrap,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
        },
      });

      contentTimeline.to(content[0], { x: () => getOffset(content[0]), ease: "none" }, 0);
      contentTimeline.to(content[1], { x: 0, ease: "none" }, 0);
    }

    function handleResize() {
      // Reagisco solo ai cambi di larghezza (rotazione, resize desktop): su mobile
      // il solo cambio di altezza è la barra degli indirizzi che compare/scompare
      // mentre si scrolla, e un refresh in quel momento sfasa l'animazione.
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initContentScroll();
        ScrollTrigger.refresh();
      }, 150);
    }

    function initSpriteScroll() {
      initContentScroll();
      const canvas = section.querySelector('.sprite-scroll__canvas');
      const pinEl = section.querySelector('.sprite-scroll__pin');
      if (!canvas || !pinEl) return;

      const ctx = canvas.getContext("2d");
      const total = parseInt(canvas.dataset.total, 10);
      const base = canvas.dataset.base;

      const framePath = (i) =>
        `${base}/frame_${String(i).padStart(3, "0")}.webp`;

      const images = [];
      let loaded = 0;

      const state = { frame: 0 };

      function render() {
        const img = images[state.frame];
        if (!img || !img.complete) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      }

      for (let i = 0; i < total; i++) {
        const img = new Image();
        img.src = framePath(i);
        img.onload = () => {
          loaded++;
          if (loaded === 1) render();
          if (loaded === total) buildTrigger();
        };
        images[i] = img;
      }

      function buildTrigger() {
        setStickyVars();
        gsap.to(state, {
          frame: total - 1,
          snap: "frame",
          ease: "none",
          scrollTrigger: {
            // Niente `pin`: il pomodoro resta fermo grazie a position: sticky.
            // Il trigger è l'overlay (position: absolute), non il canvas: il canvas
            // è sticky e durante la fase agganciata il suo rect è traslato, quindi
            // un refresh a metà scroll calcolerebbe uno start sbagliato. Il bordo
            // superiore dell'overlay coincide con quello del canvas a riposo, da cui
            // l'offset di mezza altezza per avere di nuovo "centro canvas / centro viewport".
            trigger: pinEl,
            start: () => "top center-=" + canvas.offsetHeight / 2,
            endTrigger: section.querySelector('.box-wrapper'),
            end: "center center",
            scrub: true,
            invalidateOnRefresh: true,
            onRefreshInit: setStickyVars,
          },
          onUpdate: render,
        });
        ScrollTrigger.refresh();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSpriteScroll);
    } else {
      initSpriteScroll();
    }

    window.addEventListener('resize', handleResize);
  });
}

// module stripe simple - marquee infinito con velocità costante
(function () {
  const stripes = document.querySelectorAll('.module-stripe-simple');
  if (!stripes.length) return;

  // Velocità dello scorrimento in pixel al secondo (uguale per tutti i contenuti).
  const STRIPE_SPEED = 80;

  stripes.forEach((section) => {
    const wrapper = section.querySelector('.stripe-wrapper');
    const track = section.querySelector('.stripe-track');
    const baseGroup = track ? track.querySelector('.stripe-group') : null;
    if (!wrapper || !track || !baseGroup) return;

    function build() {
      // Rimuovo eventuali cloni di un build precedente, tengo solo il gruppo base.
      track.querySelectorAll('.stripe-group').forEach((group, index) => {
        if (index > 0) group.remove();
      });

      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const groupWidth = baseGroup.getBoundingClientRect().width;
      if (groupWidth === 0) return;

      const itemsPerGroup = baseGroup.querySelectorAll('.item').length;
      const groupAdvance = groupWidth + gap;

      // Con un numero dispari di item l'alternanza chiaro/scuro cambierebbe parità
      // al confine tra i gruppi: sposto di due gruppi (item pari totali) così il
      // loop torna sempre sullo stesso colore e resta senza scatti.
      const unitGroups = itemsPerGroup % 2 === 0 ? 1 : 2;
      const shift = unitGroups * groupAdvance;
      const containerWidth = wrapper.getBoundingClientRect().width;

      // Quanti gruppi servono per riempire il contenitore e avere l'unità extra
      // da far scorrere senza mostrare spazi vuoti.
      const needed = Math.ceil(containerWidth / groupAdvance) + unitGroups + 1;
      for (let i = 1; i < needed; i++) {
        track.appendChild(baseGroup.cloneNode(true));
      }

      // Alternanza chiaro/scuro continua sull'indice globale, non per gruppo.
      track.querySelectorAll('.item').forEach((item, index) => {
        item.classList.toggle('is-dark', index % 2 === 1);
      });

      // Durata proporzionale alla distanza => velocità (px/s) costante.
      track.style.setProperty('--stripe-shift', shift + 'px');
      track.style.setProperty('--stripe-duration', shift / STRIPE_SPEED + 's');
    }

    build();

    // I font cambiano la larghezza del testo: ricostruisco quando sono pronti.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(build);
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 200);
    });
  });
})();

// Cookiebot - riapre il banner di consenso da qualsiasi link con `.js-cookiebot-settings`
// (delegato su document, così funziona anche per link aggiunti da menu/editor).
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.js-cookiebot-settings');

  if (!trigger) {
    return;
  }

  event.preventDefault();

  if (window.Cookiebot) {
    Cookiebot.renew();
  }
});
